if (window.fabric) {
  fabric.Object.prototype.hasControls = false;
  fabric.Object.prototype.hasBorders = false;
}

const canvas = new fabric.Canvas("image-canvas");

const appState = {
    outerMargin: 0,
    innerPadding: 10,
    innerWidth: 400,
    innerHeight: 400,
    selectedWidth: 400,
    selectedHeight: 400,
    uploadedImage: null,
    scaleFactor: 1,
    angle: 0,
    zoom: 1.0,
    minZoom: 0.1,
    maxZoom: 3.0,
    clipPath: null,
    outerFrame: null,
    innerCanvas: null,
    borderSize: 0.75,
    borderColor: "#000000",
    canvasBgColor: "#ffffff",
    canvasBorderColor: "#00060",
    canvasWidth: 0,
    canvasHeight: 0,
    newCanvasWidth: 0,
    newCanvasHeight: 0,
    imageWidth: 0,
    imageHeight: 0,
    newimageleft: 0,
    newimagetop: 0,
    border: 0,
    selectedEdgeType: "FitToEdge",
};

// ============================================
// HEIC/HEIF CONVERSION SUPPORT (for Chrome & non-Apple browsers)
// ============================================
let _posterPdpHeic2AnyLoaded = false;
let _posterPdpHeic2AnyLoading = false;

function posterPdpIsHeicFile(file) {
    if (!file) return false;
    if (file.type === "image/heic" || file.type === "image/heif") return true;
    if (file.name && file.name.match(/\.(heic|heif)$/i)) return true;
    return false;
}

async function posterPdpLoadHeic2Any() {
    if (_posterPdpHeic2AnyLoaded) return true;
    if (typeof window.heic2any !== "undefined") {
        _posterPdpHeic2AnyLoaded = true;
        return true;
    }

    if (_posterPdpHeic2AnyLoading) {
        while (_posterPdpHeic2AnyLoading) {
            await new Promise(r => setTimeout(r, 100));
        }
        return _posterPdpHeic2AnyLoaded;
    }

    _posterPdpHeic2AnyLoading = true;
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js";
        script.onload = () => {
            _posterPdpHeic2AnyLoaded = true;
            _posterPdpHeic2AnyLoading = false;
            resolve(true);
        };
        script.onerror = () => {
            console.error("Failed to load heic2any script");
            _posterPdpHeic2AnyLoaded = false;
            _posterPdpHeic2AnyLoading = false;
            resolve(false);
        };
        document.head.appendChild(script);
    });
}

async function posterPdpConvertHeicToJpeg(file) {
    try {
        const loaded = await posterPdpLoadHeic2Any();
        if (!loaded) return file;

        // HEIC to JPEG
        const resultBlob = await window.heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.9
        });

        let newFilename = file.name ? file.name.replace(/\.(heic|heif)$/i, ".jpg") : "converted.jpg";
        const newFile = new File([resultBlob], newFilename, {
            type: "image/jpeg",
            lastModified: new Date().getTime()
        });

        return newFile;
    } catch (err) {
        console.error("heic2any error:", err);
        alert("Warning: Could not convert HEIC format. The image might not display properly.");
        return file;
    }
}

// ===========================================
// PINCH TO ZOOM FUNCTIONALITY FOR MOBILE
// ===========================================
// Variables for pinch zoom
let initialDistance = 0;
let initialZoom = 1;
let lastCenter = { x: 0, y: 0 };
let isPinching = false;
let lastTouchTime = 0;
let lastScale = 1;
let pinchEndCooldownUntil = 0;

// Function to calculate distance between two touch points
function getTouchDistance(touch1, touch2) {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
}

// Function to calculate center point between two touches
function getTouchCenter(touch1, touch2) {
    return {
        x: (touch1.clientX + touch2.clientX) / 2,
        y: (touch1.clientY + touch2.clientY) / 2
    };
}

// Convert screen coordinates to canvas coordinates
function screenToCanvas(x, y) {
    const canvasRect = canvas.getElement().getBoundingClientRect();
    const zoom = canvas.getZoom ? canvas.getZoom() : 1;
    return {
        x: (x - canvasRect.left) / zoom,
        y: (y - canvasRect.top) / zoom
    };
}

// Touch start event
canvas.wrapperEl.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2 && appState.uploadedImage) {
        e.preventDefault();
        e.stopPropagation();

        const touch1 = e.touches[0];
        const touch2 = e.touches[1];

        initialDistance = getTouchDistance(touch1, touch2);
        initialZoom = getCurrentImageZoom();
        lastScale = appState.uploadedImage.scaleX || 1;
        lastCenter = getTouchCenter(touch1, touch2);
        isPinching = true;

        // Store the timestamp to prevent double-tap zoom
        lastTouchTime = Date.now();
    }
}, { passive: false });

// Touch move event - handles both pinch zoom and panning
canvas.wrapperEl.addEventListener('touchmove', function (e) {
    if (e.touches.length === 2 && appState.uploadedImage && isPinching) {
        e.preventDefault();
        e.stopPropagation();

        const touch1 = e.touches[0];
        const touch2 = e.touches[1];

        const currentDistance = getTouchDistance(touch1, touch2);
        const currentCenter = getTouchCenter(touch1, touch2);

        // Calculate zoom factor
        const zoomFactor = currentDistance / initialDistance;
        let requestedPinchZoom = initialZoom * zoomFactor;

        // Apply zoom constraints + DPI clamp
        requestedPinchZoom = Math.max(appState.minZoom, Math.min(appState.maxZoom, requestedPinchZoom));
        const clampedPinchZoom = clampZoomByDpi(requestedPinchZoom, MIN_PRINT_DPI);
        const baseScale = getBaseScale();
        const dpiSafeScale = baseScale > 0 ? (baseScale * clampedPinchZoom) : appState.uploadedImage.scaleX;

        // Calculate translation (panning during pinch)
        const deltaX = currentCenter.x - lastCenter.x;
        const deltaY = currentCenter.y - lastCenter.y;

        // Get image object
        const img = appState.uploadedImage;
        const oldScale = img.scaleX || 1;
        const scaleChange = dpiSafeScale / oldScale;

        // Calculate new position to maintain pinch center
        const canvasCoords = screenToCanvas(lastCenter.x, lastCenter.y);

        // Get current image center in canvas coordinates
        const imgCenterX = img.left;
        const imgCenterY = img.top;

        // Calculate offset from touch point to image center
        const offsetX = canvasCoords.x - imgCenterX;
        const offsetY = canvasCoords.y - imgCenterY;

        // Calculate new image position to keep the pinch center fixed
        const newLeft = canvasCoords.x - offsetX * scaleChange;
        const newTop = canvasCoords.y - offsetY * scaleChange;

        // Apply new scale and position
        img.scaleX = dpiSafeScale;
        img.scaleY = dpiSafeScale;
        img.left = newLeft;
        img.top = newTop;

        // Also apply panning from finger movement
        const zoom = canvas.getZoom ? canvas.getZoom() : 1;
        img.left += deltaX / zoom;
        img.top += deltaY / zoom;

        img.setCoords();
        appState.zoom = clampedPinchZoom;
        appState.scaleFactor = dpiSafeScale;

        // Update center for next move
        lastCenter = currentCenter;

        // Update UI elements
        updateMovementConstraints();
        updatePositionInfo();

        syncZoomSlider();
        updateZoomControlsState();

        if (requestedPinchZoom > (clampedPinchZoom + 0.000001)) {
            showZoomLimitMessage();
        }

        canvas.requestRenderAll();
    } else if (e.touches.length === 1 && appState.uploadedImage && !isPinching) {
        // Single finger touch - allow fabric.js to handle panning
        // We'll update position info after movement
        requestAnimationFrame(() => {
            updatePositionInfo();
        });
    }
}, { passive: false });

// Touch end event
canvas.wrapperEl.addEventListener('touchend', function (e) {
    const wasPinching = isPinching;
    if (isPinching) {
        isPinching = false;

        // Reset variables
        initialDistance = 0;
        initialZoom = 1;
        lastCenter = { x: 0, y: 0 };

        // Sync slider with current zoom
        const slider = document.getElementById("zoomSlider");
        if (slider) {
            slider.value = String(Math.round(appState.zoom * 100));
            updateSliderBackground(slider);
        }

        canvas.requestRenderAll();
        lastTouchTime = Date.now();
        pinchEndCooldownUntil = Date.now() + 350;
        return;
    }

    // Handle double tap for zoom reset
    if (wasPinching) {
        lastTouchTime = Date.now();
        pinchEndCooldownUntil = Date.now() + 350;
        return;
    }

    const currentTime = Date.now();
    if (currentTime < pinchEndCooldownUntil) {
        lastTouchTime = currentTime;
        return;
    }
    const timeDiff = currentTime - lastTouchTime;

    if (timeDiff < 300 && e.touches.length === 0 && e.changedTouches.length === 1) {
        // Double tap detected - reset zoom to fit
        if (appState.uploadedImage) {
            // Animate zoom reset
            resetZoom();
            fitImageToFrame(false);
        }
    }

    lastTouchTime = currentTime;
});

// Touch cancel event
canvas.wrapperEl.addEventListener('touchcancel', function () {
    isPinching = false;
    initialDistance = 0;
    initialZoom = 1;
    lastCenter = { x: 0, y: 0 };
    pinchEndCooldownUntil = Date.now() + 350;
});

// Prevent default touch actions on canvas
canvas.wrapperEl.style.touchAction = 'none';
canvas.wrapperEl.style.webkitUserSelect = 'none';
canvas.wrapperEl.style.userSelect = 'none';

// Also add touch event listeners to the canvas element itself
canvas.getElement().addEventListener('touchstart', function (e) {
    if (e.touches.length === 2 && appState.uploadedImage) {
        e.preventDefault();
    }
}, { passive: false });

canvas.getElement().addEventListener('touchmove', function (e) {
    if (e.touches.length === 2 && appState.uploadedImage) {
        e.preventDefault();
    }
}, { passive: false });

// Add pinch zoom indicator (optional visual feedback)
function showPinchFeedback() {
    const feedback = document.createElement('div');
    feedback.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0,0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10000;
    pointer-events: none;
    transition: opacity 0.3s;
  `;
    feedback.textContent = 'Pinch to zoom';
    document.body.appendChild(feedback);

    setTimeout(() => {
        feedback.style.opacity = '0';
        setTimeout(() => {
            document.body.removeChild(feedback);
        }, 300);
    }, 1500);
}

// Show pinch hint on mobile devices on first interaction
if ('ontouchstart' in window && window.innerWidth < 768) {
    let pinchHintShown = localStorage.getItem('pinchHintShown');
    if (!pinchHintShown) {
        setTimeout(() => {
            if (appState.uploadedImage) {
                showPinchFeedback();
                localStorage.setItem('pinchHintShown', 'true');
            }
        }, 2000);
    }
}



// ============================
// CENTER GUIDELINES WITH SNAPPING
// ============================
let vCenterLine, hCenterLine;
const THRESHOLD = 10; // 4px threshold for snapping

// Function to create center lines (always visible)
function createCenterLines() {
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    // Remove existing lines if any
    if (vCenterLine) canvas.remove(vCenterLine);
    if (hCenterLine) canvas.remove(hCenterLine);

    // Create vertical center line
    vCenterLine = new fabric.Line(
        [centerX, 0, centerX, canvas.height],
        {
            stroke: 'red',
            strokeWidth: 1,
            selectable: false,
            evented: false,
            opacity: 0.3, // Semi-transparent
            name: 'centerLine',
            strokeDashArray: [5, 5] // Dashed line for better visibility
        }
    );

    // Create horizontal center line
    hCenterLine = new fabric.Line(
        [0, centerY, canvas.width, centerY],
        {
            stroke: 'red',
            strokeWidth: 1,
            selectable: false,
            evented: false,
            opacity: 0.3, // Semi-transparent
            name: 'centerLine',
            strokeDashArray: [5, 5] // Dashed line for better visibility
        }
    );

    canvas.add(vCenterLine);
    canvas.add(hCenterLine);
    bringCenterLinesToFront();
    canvas.requestRenderAll();
}

// Function to update center lines position
function updateCenterLines() {
    if (!vCenterLine || !hCenterLine) {
        createCenterLines();
        return;
    }

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    vCenterLine.set({
        x1: centerX,
        y1: 0,
        x2: centerX,
        y2: canvas.height
    });

    hCenterLine.set({
        x1: 0,
        y1: centerY,
        x2: canvas.width,
        y2: centerY
    });

    bringCenterLinesToFront();
    canvas.requestRenderAll();
}



const mockupPlacements = [
    { x: 0.3545, y: 0.199, w: 0.295, h: 0.375 },
    { x: 0.382, y: 0.354, w: 0.23, h: 0.292 },
    { x: 0.373, y: 0.106, w: 0.104, h: 0.132 },
    { x: 0.376, y: 0.488, w: 0.246, h: 0.311 },
];

const mockupState = {
    croppedWidth: 0,
    croppedHeight: 0
};

const uploadInput = document.getElementById("upload-image");
const uploadInputwrap = document.querySelector(".upload-wrapper");
const galleryWrapper = document.getElementById("galleryWrapper");
const customForm = document.getElementById("custom-image-form");

let canvasOpsLoadingCount = 0;
let canvasOpsShownAt = 0;
let canvasOpsHideTimer = null;

function getCanvasOpsLoaderHost() {
    return document.getElementById("custom-image-form")
        || document.querySelector(".left-pdp-sticky")
        || document.querySelector("#splitView .canvas-panel.left-panel");
}

function ensureCanvasOpsLoader(host) {
    if (!host) return null;

    const styleId = "canvas-ops-loader-style-poster";
    if (!document.getElementById(styleId)) {
        const style = document.createElement("style");
        style.id = styleId;
        style.textContent = `
           .canvas-ops-loader{
        position:absolute;
        inset:0;
        z-index: 0;
        display:none;
        align-items:center;
        justify-content:center;
        flex-direction:column;
        gap:8px;
        background: #090909;
        backdrop-filter: blur(2px);
      }
      .canvas-ops-loader.active{ display:flex; }
      .canvas-ops-loader__spinner{
        width:40px;
        height:40px;
        border:3px solid rgba(255,255,255,0.24);
        border-top-color:#fff;
        border-radius:50%;
        animation: canvasOpsSpin 0.9s linear infinite;
        display:block !important;
      }
      .canvas-ops-loader__text{
        color:#fff;
        font-size:12px;
        letter-spacing:0.02em;
      }
      @keyframes canvasOpsSpin { to { transform: rotate(360deg); } }
      @media (max-width: 749px){
        .canvas-ops-loader__spinner{ width:36px; height:36px; }
        .canvas-ops-loader__text{ font-size:11px; }
      }
    `;
        document.head.appendChild(style);
    }

    let loader = host.querySelector("#canvasOpsLoader");
    if (!loader) {
        if (window.getComputedStyle(host).position === "static") {
            host.style.position = "relative";
        }
        loader = document.createElement("div");
        loader.id = "canvasOpsLoader";
        loader.className = "canvas-ops-loader";
        loader.innerHTML = '<div class="canvas-ops-loader__spinner"></div><div class="canvas-ops-loader__text">Rendering preview...</div>';
        host.appendChild(loader);
    }
    return loader;
}

function showCanvasOpsLoader() {
    canvasOpsLoadingCount += 1;
    const host = getCanvasOpsLoaderHost();
    const loader = ensureCanvasOpsLoader(host);
    if (!loader) return;

    if (canvasOpsHideTimer) {
        clearTimeout(canvasOpsHideTimer);
        canvasOpsHideTimer = null;
    }

    canvasOpsShownAt = Date.now();
    loader.classList.add("active");
}

function hideCanvasOpsLoader() {
    canvasOpsLoadingCount = Math.max(0, canvasOpsLoadingCount - 1);
    if (canvasOpsLoadingCount > 0) return;

    const host = getCanvasOpsLoaderHost();
    const loader = host ? host.querySelector("#canvasOpsLoader") : null;
    if (!loader) return;

    const minVisibleMs = 280;
    const postCompleteDelayMs = 2000;
    const elapsed = Date.now() - canvasOpsShownAt;
    const wait = Math.max(0, minVisibleMs - elapsed) + postCompleteDelayMs;

    canvasOpsHideTimer = setTimeout(() => {
        if (canvasOpsLoadingCount === 0) {
            loader.classList.remove("active");
        }
        canvasOpsHideTimer = null;
    }, wait);
}

function waitForCanvasRenderComplete() {
    return new Promise((resolve) => {
        if (!canvas || typeof canvas.on !== "function" || typeof canvas.off !== "function") {
            requestAnimationFrame(() => requestAnimationFrame(resolve));
            return;
        }

        let finished = false;
        const finish = () => {
            if (finished) return;
            finished = true;
            try {
                canvas.off("after:render", onAfterRender);
            } catch (e) { }
            requestAnimationFrame(resolve);
        };

        const onAfterRender = () => finish();
        try {
            canvas.on("after:render", onAfterRender);
            canvas.requestRenderAll();
        } catch (e) { }

        setTimeout(finish, 260);
    });
}

canvas.on("object:scaling", function () {
    updateMovementConstraints();
    updatePositionInfo();
});

canvas.on("object:rotating", function () {
    updateMovementConstraints();
    updatePositionInfo();
});

document.querySelectorAll(".image-conform-btn").forEach(div => {
    div.style.pointerEvents = "none";
    div.style.opacity = "0.5";
});

function getImagePosition() {
    if (!appState.uploadedImage) return null;

    const img = appState.uploadedImage;
    const left = img.left - img.getScaledWidth() / 2;
    const top = img.top - img.getScaledHeight() / 2;
    const right = left + img.getScaledWidth();
    const bottom = top + img.getScaledHeight();

    return {
        left: Math.round(left),
        top: Math.round(top),
        right: Math.round(right),
        bottom: Math.round(bottom),
        width: Math.round(img.getScaledWidth()),
        height: Math.round(img.getScaledHeight()),
        scale: Math.round(img.scaleX * 100) / 100,
        angle: Math.round(img.angle),
    };
}

// Add movement constraint functions
function setMovementConstraints() {
    if (!appState.uploadedImage) return;

    const img = appState.uploadedImage;
    const width = img.getScaledWidth();
    const height = img.getScaledHeight();
    const isLandscape = width > height;
    const isPortrait = height > width;
    const isSquare = width === height;

    img.setCoords();
    canvas.requestRenderAll();
}


function updateMovementConstraints() {
    if (!appState.uploadedImage) return;

    const img = appState.uploadedImage;
    const width = img.getScaledWidth();
    const height = img.getScaledHeight();

    img.setCoords();
}

document.addEventListener("DOMContentLoaded", function () {
    const boostBtn = document.querySelector(".boost-img-btn");
    const conformBtn = document.querySelector(".image-conform-btn");

    if (!boostBtn || !conformBtn) return;

    function updateDisplay() {
        const boostDisplay = window.getComputedStyle(boostBtn).display;

        if (boostDisplay === "none") {
            conformBtn.style.display = "flex";
        } else if (boostDisplay === "flex") {
            conformBtn.style.display = "none";
        }
    }
    updateDisplay();

    const observer = new MutationObserver(updateDisplay);

    observer.observe(boostBtn, {
        attributes: true,
        attributeFilter: ["style", "class"],
        subtree: false
    });

    window.addEventListener("resize", updateDisplay);
});

function updatePositionInfo() {
    const pos = getImagePosition();
    if (!pos) return;

    document.getElementById("position-left").textContent = `${pos.left}`;
    document.getElementById("position-top").textContent = `${pos.top}`;
    document.getElementById("position-right").textContent = `${pos.right}`;
    document.getElementById("position-bottom").textContent = `${pos.bottom}`;
    document.getElementById("img-width").textContent = `${pos.width}`;
    document.getElementById("img-height").textContent = `${pos.height}`;
    document.getElementById("img-scale").textContent = pos.scale;
    document.getElementById("img-angle").textContent = `${pos.angle}°`;

    const imgwidth = pos.width || 0;
    const imgheight = pos.height || 0;
    const rvalue = document.getElementById("r")?.textContent || 1;
    const imgtop = pos.top || 0;
    const imgleft = pos.left || 0;
    const cvswElement = document.getElementById("cvs-w")?.textContent || 0;
    const cvshElement = document.getElementById("cvs-h")?.textContent || 0;
    const imageratio = Number((imgwidth / imgheight).toFixed(2));
    const finalw = (imgwidth * rvalue);
    const finalh = (imgheight * rvalue);
    const finalt = (imgtop * rvalue);
    const finall = (imgleft * rvalue);

    const currentimgw = finalw / 100;
    const currentimgh = finalh / 100;

    const filewvalue = parseFloat(document.getElementById("img-file-w")?.textContent) || 0;
    const filehvalue = parseFloat(document.getElementById("img-file-h")?.textContent) || 0;

    const dpiW = filewvalue && currentimgw ? filewvalue / currentimgw : 0;
    const dpiH = filehvalue && currentimgh ? filehvalue / currentimgh : 0;
    const dpi = Math.round((dpiW + dpiH) / 2);

    appState.finall = finall;
    appState.finalt = finalt;
    appState.finalw = finalw;
    appState.finalh = finalh;
    appState.dpi = dpi;
    appState.printimghight = currentimgh;
    appState.printimgwidth = currentimgw;
    const newcanvasW = (appState.extendwidth * appState.dpi);
    appState.newCanvasWidth = newcanvasW;
    const newcanvasH = (appState.extendheight * appState.dpi);
    appState.newCanvasHeight = newcanvasH;
    const newborder = (0.75 * appState.dpi);
    appState.newBorder = newborder;
    const imageleft = ((finall * appState.dpi) / 100);
    appState.newimageleft = imageleft;
    const imagetop = ((finalt * appState.dpi) / 100);
    appState.newimagetop = imagetop;
    appState.imageWidth = filewvalue;
    appState.imageheight = filehvalue;

    updateZoomControlsState();
    updateDpiDisplay();
    document.getElementById("final-dpi").textContent = dpi.toFixed(2);
    document.getElementById("img-f-w").textContent = finalw;
    document.getElementById("img-f-h").textContent = finalh;
    document.getElementById("f-t").textContent = finalt;
    document.getElementById("f-l").textContent = finall;
    document.getElementById("img-ratio").textContent = imageratio;
    document.getElementById("current-img-w").textContent = currentimgw;
    document.getElementById("current-img-h").textContent = currentimgh;


    const hiddenimg = document.getElementById("frame-img-position");
    const orientationRadio = document.querySelector('input[name="orientation"]:checked');
    const orientation = orientationRadio ? orientationRadio.value : "portrait";

    if (orientation == "portrait") {
        if (hiddenimg) {
            hiddenimg.value = JSON.stringify({
                area_width: cvswElement,
                area_height: cvshElement,
                width: finalw,
                height: finalh,
                top: finalt,
                left: finall,
            });
        }
    }
    else if (orientation == "landscape") {
        if (hiddenimg) {
            hiddenimg.value = JSON.stringify({
                area_width: cvshElement,
                area_height: cvswElement,
                width: finalw,
                height: finalh,
                top: finalt,
                left: finall,
            });
        }
    }

}

function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
}

// const dpiElements = document.querySelectorAll(".dpi-num");
// const iconElements = document.querySelectorAll(".dpi-state-icon");
const boostBtn = document.querySelector(".boost-img-btn");

boostBtn.style.display = "none";

function updateDpiDisplay() {

    // const dpiElement = document.querySelector(".dpi-num");
    // const iconElements = document.querySelectorAll(".dpi-state-icon");
    const boostBtn = document.querySelector(".boost-img-btn");
    const confirmBtn = document.querySelector(".image-conform-btn");

    const currentDpi = Number((appState.dpi || 0).toFixed(2));

    if (!boostBtn) return;

    //  Clear all icons first
    // iconElements.forEach(el => {
    //   el.innerHTML = "";
    // });

    if (currentDpi > 0 && currentDpi < 30) {
        //  dpiElement.textContent = `Needs Upscale`;
        //   dpiElement.style.color = "red";

        //   iconElements.forEach(el => {
        //     el.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M9.9891 0C4.49317 0 0 4.49317 0 9.9891C0 15.4859 4.49317 20 9.9891 20C15.485 20 20 15.5068 20 9.9891C20 4.47115 15.5068 0 9.9891 0ZM9.9891 18.3208C5.40912 18.3208 1.67946 14.5911 1.67946 10.0111C1.67946 5.43115 5.40912 1.70148 9.9891 1.70148C14.5691 1.70148 18.2987 5.43115 18.2987 10.0111C18.3207 14.5911 14.5909 18.3208 9.9891 18.3208Z" fill="#FF0606"/>
        //     <path d="M10.1207 4.56252C9.74952 4.56252 9.44421 4.69326 9.20466 4.93365C8.98621 5.1732 8.85547 5.52239 8.85547 5.93651C8.85547 6.24185 8.8774 6.72177 8.92126 7.41931L9.16081 10.9307C9.20466 11.4106 9.29154 11.7379 9.37926 11.9774C9.48806 12.2389 9.70651 12.3696 10.0118 12.3696C10.3172 12.3696 10.5137 12.2389 10.6444 11.9774C10.7532 11.7379 10.841 11.3887 10.8629 10.9526L11.1682 7.33156C11.2121 7.0043 11.2121 6.65511 11.2121 6.34977C11.2121 5.78297 11.1463 5.34691 10.9936 5.04073C10.884 4.7371 10.5787 4.56252 10.1207 4.56252Z" fill="#FF0606"/>
        //     <path d="M10.0549 13.4844C9.72761 13.4844 9.44421 13.5932 9.20466 13.8336C8.96511 14.0731 8.85547 14.3354 8.85547 14.6627C8.85547 15.0338 8.9862 15.3391 9.2266 15.5348C9.46615 15.7313 9.75039 15.8402 10.0768 15.8402C10.3821 15.8402 10.6655 15.7313 10.9059 15.5129C11.1455 15.2944 11.277 14.6408 11.277 14.6408C11.277 14.3135 11.1682 14.0301 10.9278 13.7906C10.6655 13.5932 10.3813 13.4844 10.0549 13.4844Z" fill="#FF0606"/>
        //   </svg>`;
        //   });

        boostBtn.style.display = "flex";
        boostBtn.classList.add("show");

    } else if (currentDpi >= 30) {
        //    dpiElement.textContent = `Good To Print`;
        //     dpiElement.style.color = "green";

        //     iconElements.forEach(el => {
        //       el.innerHTML =`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        // <path d="M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 17.8105C5.68421 17.8105 2.18947 14.2947 2.18947 10C2.18947 5.70526 5.68421 2.18947 10 2.18947C14.3158 2.18947 17.8105 5.68421 17.8105 10C17.8105 14.3158 14.3158 17.8105 10 17.8105Z" fill="#1B8600"/>
        // <path d="M12.7139 6.92258L8.90337 10.7542L7.28232 9.13311C6.86127 8.71205 6.16653 8.71205 5.74548 9.13311C5.32442 9.55416 5.32442 10.2489 5.74548 10.6699L8.14548 13.0699C8.356 13.2805 8.62969 13.3857 8.92443 13.3857C9.21916 13.3857 9.49285 13.2805 9.70337 13.0699L14.2928 8.48047C14.7139 8.05942 14.7139 7.36469 14.2928 6.94363C13.8507 6.50153 13.156 6.50153 12.7139 6.92258Z" fill="#1B8600"/>
        // </svg>`;

        //     });

        boostBtn.classList.remove("show");
        boostBtn.style.display = "none";

    } else if (currentDpi === 0) {
        boostBtn.classList.remove("show");

        setTimeout(() => {
            if (!boostBtn.classList.contains("show")) {
                boostBtn.style.display = "none";
                if (confirmBtn) {
                    confirmBtn.style.display = "flex";
                }
            }
        }, 300);
    }
}


function updateFrameFromPixels(width, height, width1, height1) {
    canvas.setWidth(width + appState.outerMargin * 2);
    canvas.setHeight(height + appState.outerMargin * 2);
    const frnheight = appState.originalHeight;
    const frmwidth = appState.originalWidth;
    let size = `${frmwidth}x${frnheight}`;

    const sortedSize = [frmwidth, frnheight].sort((a, b) => a - b).join("x");

    let innerPadding = 0;


    appState.innerWidth = width - innerPadding * 2;
    appState.innerHeight = height - innerPadding * 2;

    canvas.clear();

    if (appState.uploadedImage) {
        appState.uploadedImage.clipPath = null;
        appState.uploadedImage.originX = 0;
        appState.uploadedImage.originY = 0;
        appState.uploadedImage.left = 0;
        appState.uploadedImage.top = 0;
        appState.uploadedImage.scaleToWidth(width);
        appState.uploadedImage.scaleToHeight(height);

        canvas.add(appState.uploadedImage);
        canvas.setActiveObject(appState.uploadedImage);
    }

    const borderSize = innerPadding;


    canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));
    canvas.off("after:render");
    canvas.requestRenderAll();
    updatePositionInfo();
}



function fitImageToFrame(cover = false) {
    if (!appState.uploadedImage) {
        return;
    }

    const W = appState.uploadedImage.width;
    const H = appState.uploadedImage.height;

    const scaleX = appState.selectedWidth / W;
    const scaleY = appState.selectedHeight / H;

    let newScale = cover ? Math.max(scaleX, scaleY) : Math.min(scaleX, scaleY);
    if (!isFinite(newScale) || newScale <= 0) {
        newScale = 1;
    }

    appState.uploadedImage.scaleX = newScale;
    appState.uploadedImage.scaleY = newScale;
    appState.scaleFactor = newScale;

    updateMovementConstraints();
    centerImage();
    appState.uploadedImage.setCoords();
    syncZoomSlider();
    const wasCapped = enforceMinimumDpi(MIN_PRINT_DPI);
    if (wasCapped) {
        showZoomLimitMessage();
    }
    updatePositionInfo();
    canvas.requestRenderAll();
}

function centerImage() {
    if (!appState.uploadedImage) return;
    const centerX = appState.selectedWidth / 2;
    const centerY = appState.selectedHeight / 2;
    appState.uploadedImage.originX = "center";
    appState.uploadedImage.originY = "center";
    appState.uploadedImage.left = centerX;
    appState.uploadedImage.top = centerY;
    appState.uploadedImage.setCoords();
    canvas.requestRenderAll();
    updatePositionInfo();
}


document.getElementById("zoomIn").addEventListener("click", () => {
    zoomIn();
});

document.getElementById("zoomOut").addEventListener("click", () => {
    zoomOut();
});

function updateFrameSize(selectedOption) {
    const resolvedSizeOption =
        (selectedOption && selectedOption.name === "frameSize")
            ? selectedOption
            : document.querySelector('#frameSizeOptions [name="frameSize"]:checked');

    if (!resolvedSizeOption) return;

    // Get orientation selection
    const selectedRadio = document.querySelector('input[name="orientation"]:checked');
    const selectedOrientation = selectedRadio ? selectedRadio.value : "portrait";
    const selectedsize = document.querySelector('input[name="frameSize"]:checked');
    document.querySelectorAll(".selected-size").forEach(el => {
        el.textContent = selectedsize ? selectedsize.value : "";
    });
    // Get frame size data from selected option
    const originalsize = resolvedSizeOption.getAttribute("data-original-size");
    const [width1, height1] = originalsize.split("x").map(Number);

    let dataratio;
    let size;
    if (window.innerWidth < 680) {
        size = resolvedSizeOption.getAttribute("data-pixel-mobile");
        dataratio = resolvedSizeOption.getAttribute("data-ratio-mobile");
    } else {
        size = resolvedSizeOption.getAttribute("data-pixel-desktop");
        dataratio = resolvedSizeOption.getAttribute("data-ratio-desktop");
    }

    const frmsize = resolvedSizeOption.getAttribute("data-frmsize");
    const [width, height] = size.split("x").map(Number);
    const [frmwidth, frmheight] = frmsize.replace(/″/g, '').split('×').map(s => Number(s.trim()));

    // Calculate extended dimensions
    const extendwidth = frmwidth + 3;
    const extendheight = frmheight + 3;

    // Set values based on orientation
    if (selectedOrientation === "portrait") {
        appState.originalWidth = width1;
        appState.originalHeight = height1;
        appState.selectedWidth = width;
        appState.selectedHeight = height;
        appState.extendheight = extendheight;
        appState.extendwidth = extendwidth;
    } else { // landscape
        appState.originalWidth = height1;
        appState.originalHeight = width1;
        appState.selectedWidth = height;
        appState.selectedHeight = width;
        appState.extendheight = extendwidth;
        appState.extendwidth = extendheight;
    }

    // Update UI elements
    updateFrameFromPixels(appState.selectedWidth, appState.selectedHeight, appState.originalWidth, appState.originalHeight);

    const cvswElement = document.getElementById("cvs-w");
    const cvshElement = document.getElementById("cvs-h");
    const orgWElement = document.getElementById("org-w");
    const orgHElement = document.getElementById("org-h");
    const frnWElement = document.getElementById("frm-w");
    const frmHElement = document.getElementById("frm-h");
    const ratioElement = document.getElementById("r");

    if (orgWElement) orgWElement.textContent = appState.originalWidth;
    if (orgHElement) orgHElement.textContent = appState.originalHeight;
    if (frnWElement) frnWElement.textContent = appState.selectedWidth;
    if (frmHElement) frmHElement.textContent = appState.selectedHeight;
    if (ratioElement) ratioElement.textContent = dataratio;
    if (cvswElement) cvswElement.textContent = appState.originalWidth;
    if (cvshElement) cvshElement.textContent = appState.originalHeight;

    // Handle canvas updates
    canvas.setWidth(appState.selectedWidth);
    canvas.setHeight(appState.selectedHeight);

    // Update all canvas objects
    canvas.getObjects().forEach(obj => {
        obj.set({
            scaleX: obj.scaleX,
            scaleY: obj.scaleY,
            left: obj.left,
            top: obj.top
        });
        obj.setCoords();
    });

    canvas.renderAll();

    // Handle uploaded image if exists
    if (appState.uploadedImage) {
        appState.uploadedImage.clipPath = appState.clipPath;
        canvas.add(appState.uploadedImage);
        fitImageToFrame(true);
    }

    updatePositionInfo();


    fitImageToFrame(true);
    enforceMinimumDpi(MIN_PRINT_DPI);


    // DPI display logic
    updateDpiDisplay();
}

function handleOrientationChange() {
    // Get the currently selected frame size option
    const selectedSizeOption = document.querySelector('#frameSizeOptions [name="frameSize"]:checked');
    if (selectedSizeOption) {
        updateFrameSize(selectedSizeOption);
    }
}

document.getElementById("frameSizeOptions").addEventListener("change", function (e) {
    if (e.target.name === "frameSize") {
        updateFrameSize(e.target);
    }
});


window.addEventListener("load", () => {
    const selectedOption = document.querySelector('#frameSizeOptions [name="frameSize"]:checked');
    if (selectedOption) {
        updateFrameSize(selectedOption);
    }
});

document.getElementById("frameOrientationOptions").addEventListener("change", function (e) {
    if (e.target.name === "orientation") {
        handleOrientationChange();
    }
});


window.addEventListener("load", () => {
    const selectedOption = document.querySelector('#frameOrientationOptions [ name="orientation" ]:checked');
    if (selectedOption) {
        updateFrameSize(selectedOption);
    }
});



canvas.on('object:moving', function (e) {
    const obj = e.target;

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    // Get object center point
    const objCenter = obj.getCenterPoint();

    // Calculate distances from center
    const distX = Math.abs(objCenter.x - centerX);
    const distY = Math.abs(objCenter.y - centerY);

    // Remove existing center lines first
    if (vCenterLine) {
        canvas.remove(vCenterLine);
        vCenterLine = null;
    }
    if (hCenterLine) {
        canvas.remove(hCenterLine);
        hCenterLine = null;
    }

    // Check if object should snap to vertical center
    if (distX < THRESHOLD) {
        // For center-origin objects, just set left to centerX
        obj.set({
            left: centerX
        });

        // Create and show vertical center line
        vCenterLine = new fabric.Line(
            [centerX, 0, centerX, canvas.height],
            {
                stroke: 'red',
                strokeWidth: 1,
                selectable: false,
                evented: false,
                opacity: 0.7, // Slightly transparent
                name: 'centerLine'
            }
        );

        canvas.add(vCenterLine);
        // Ensure the line is on top
        canvas.moveTo(vCenterLine, 9999);
    }

    // Check if object should snap to horizontal center
    if (distY < THRESHOLD) {
        // For center-origin objects, just set top to centerY
        obj.set({
            top: centerY
        });

        // Create and show horizontal center line
        hCenterLine = new fabric.Line(
            [0, centerY, canvas.width, centerY],
            {
                stroke: 'red',
                strokeWidth: 1,
                selectable: false,
                evented: false,
                opacity: 0.7, // Slightly transparent
                name: 'centerLine'
            }
        );

        canvas.add(hCenterLine);
        // Ensure the line is on top
        canvas.moveTo(hCenterLine, 9999);
    }

    updatePositionInfo();
    obj.setCoords();

    // If object was snapped, we need to render
    if (distX < THRESHOLD || distY < THRESHOLD) {
        canvas.requestRenderAll();
    }
});

// Add this function to always keep center lines on top
canvas.on('object:added', function (e) {
    if (e.target.name === 'centerLine') {
        canvas.moveTo(e.target, 9999);
    }
});

// Also update your object:modified event to properly handle lines
canvas.on('object:modified', function (e) {
    // Only remove center lines if we're modifying a non-line object
    if (e.target.name !== 'centerLine') {
        if (vCenterLine) {
            canvas.remove(vCenterLine);
            vCenterLine = null;
        }
        if (hCenterLine) {
            canvas.remove(hCenterLine);
            hCenterLine = null;
        }
    }

    updatePositionInfo();
    canvas.requestRenderAll();
});


function uploadImageToAPI(file) {
    const formData = new FormData();
    const userId = window.shopifyCustomerId || "guest";
    const sessionId = getLocalStorage1Day("sessionId") || "none";
    formData.append('file', file);
    formData.append('customerId', userId);
    formData.append('sessionId', sessionId);
    formData.append('megamenu', "true");

    fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
        method: "POST",
        headers: {
            "x-api-key": window.Prompt2Prints.apiKey
        },
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            // ✅ Store cloudfrontLink in localStorage
            if (data?.cloudfrontLink) {
                localStorage.setItem("pdpUploadedImage", data.cloudfrontLink);
            } else {
                console.warn("cloudfrontLink not found in API response");
            }
            const imageUpscale = document.querySelector('input[name="properties[_pdp-allow-upscale]"]');
            const imageUpscaletag = document.querySelector('input[name="properties[_pdp-img-tag]"]');


            if (!imageUpscale) {
                return;
            }

            const flag = (data.flag || "").toLowerCase();

            if (flag === "standard") {
                imageUpscale.value = "true";
                imageUpscaletag.value = "Standard";
            }
            else if (flag === "professional") {
                imageUpscale.value = "false";
                imageUpscaletag.value = "Professional";
            }
            else {
            }
        })
        .catch(err => {
            console.error("Image upload failed:", err);
        });
}


uploadInput.addEventListener("change", function (e) {
    (async () => {
        let file = e.target.files[0];
        if (!file) return;

        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/heic",
            "image/heif"
        ];

        if (!allowedTypes.includes(file.type) && !posterPdpIsHeicFile(file)) {
            alert("Only JPEG, PNG, or HEIC images are allowed.");
            uploadInput.value = "";
            return;
        }

        showCanvasOpsLoader();
        try {
            if (posterPdpIsHeicFile(file)) {
                try {
                    file = await posterPdpConvertHeicToJpeg(file);
                    if (!file) {
                        uploadInput.value = "";
                        return;
                    }
                } catch (err) {
                    console.error("HEIC conversion failed:", err);
                    uploadInput.value = "";
                    return;
                }
            }

            appState.uploadimgsize = +(file.size / (1024 * 1024)).toFixed(2);
            uploadImageToAPI(file);

            const dataUrl = await new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = function () {
                    const reader = new FileReader();
                    reader.onload = function (f) {
                        resolve(f.target.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                };
                img.onerror = reject;
                img.src = URL.createObjectURL(file);
            });

            galleryWrapper.style.display = "none";
            uploadInputwrap.style.display = "none";
            customForm.style.display = "block";

            await new Promise((resolve, reject) => {
                const mainImgWrap = document.querySelector(".main-img-wrap");
                if (mainImgWrap) {
                    mainImgWrap.setAttribute("data-main-img", dataUrl);
                }

                fabric.Image.fromURL(dataUrl, function (fabricImg) {
                    try {
                        appState.uploadedImage = fabricImg;
                        const imgfileWElement = document.getElementById("img-file-w");
                        const imgfileHElement = document.getElementById("img-file-h");

                        if (imgfileWElement) imgfileWElement.textContent = fabricImg.width;
                        if (imgfileHElement) imgfileHElement.textContent = fabricImg.height;

                        appState.uploadedImage.set({
                            selectable: true,
                            evented: true,
                            hasBorders: false,
                            hasControls: false,
                            lockRotation: true,
                            lockScalingFlip: true,
                            lockUniScaling: true,
                            lockMovementX: false,
                            lockMovementY: false,
                            originX: "center",
                            originY: "center",
                            clipPath: appState.clipPath,
                        });

                        appState.uploadedImage.setControlsVisibility({
                            mt: false,
                            mb: false,
                            ml: false,
                            mr: false,
                            mtr: false,
                        });

                        canvas.add(appState.uploadedImage);
                        setMovementConstraints();
                        canvas.setActiveObject(appState.uploadedImage);
                        canvas.moveTo(appState.uploadedImage, 2);
                        fitImageToFrame(true);
                        canvas.requestRenderAll();
                        syncZoomSlider();
                        requestAnimationFrame(resolve);
                    } catch (error) {
                        reject(error);
                    }
                });
            });

            document.querySelectorAll(".image-conform-btn").forEach(div => {
                div.style.pointerEvents = "auto";
                div.style.opacity = "1";
            });
        } catch (error) {
            console.error("Failed to process uploaded image:", error);
        } finally {
            await waitForCanvasRenderComplete();
            hideCanvasOpsLoader();
        }
    })();
});

const slider = document.getElementById("zoomSlider");
const zoomInBtn = document.getElementById("zoomIn");
const zoomOutBtn = document.getElementById("zoomOut");
const zoomLabel = document.getElementById("zoomLabel");

const canvasW = parseFloat(document.getElementById("frm-w")?.textContent) || 1;
const canvasH = parseFloat(document.getElementById("frm-h")?.textContent) || 1;

let imgWidthInches = 6;
let imgHeightInches = 4;
let scale = 1;

function isEdgesEnabled() {
    const blackCheckbox = document.getElementById("enable-edges-black");
    const whiteCheckbox = document.getElementById("enable-edges-white");

    const blackChecked = blackCheckbox ? blackCheckbox.checked : false;
    const whiteChecked = whiteCheckbox ? whiteCheckbox.checked : false;

    return blackChecked || whiteChecked;
}


function updateSliderBackground(slider) {
    if (!slider) return;

    const value = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;

    const currentDpi = Number((appState.dpi || 0).toFixed(2));

    let backgroundColor;
    if (currentDpi < 30) {
        backgroundColor = `linear-gradient(to right, #1F8FE5 ${value}%, #ff4444 ${value}%)`;
        slider.classList.add('dpi-warning-slider');
    } else {
        backgroundColor = `linear-gradient(to right, #1F8FE5 ${value}%, rgb(255, 255, 255) ${value}%)`;
        slider.classList.remove('dpi-warning-slider');
    }

    slider.style.background = backgroundColor;
}

const MIN_PRINT_DPI = 30;
let zoomLimitToastTimer = null;
let zoomLimitToastEl = null;

function getCurrentImageZoom() {
    if (!appState.uploadedImage) return appState.zoom || 1;

    const baseScale = getBaseScale();
    if (baseScale <= 0 || !isFinite(baseScale)) return appState.zoom || 1;

    const currentZoom = appState.uploadedImage.scaleX / baseScale;
    if (!isFinite(currentZoom) || currentZoom <= 0) return appState.zoom || 1;

    return currentZoom;
}

function getMaxZoomForMinDpi(minDpi = MIN_PRINT_DPI) {
    const currentDpi = Number(appState.dpi || 0);
    const currentZoom = getCurrentImageZoom();

    if (!isFinite(currentDpi) || currentDpi <= 0 || !isFinite(currentZoom) || currentZoom <= 0) {
        return appState.maxZoom;
    }

    const targetZoom = currentZoom * (currentDpi / minDpi);
    if (!isFinite(targetZoom) || targetZoom <= 0) return appState.maxZoom;

    return Math.max(appState.minZoom, Math.min(appState.maxZoom, targetZoom));
}

function getDynamicMaxZoom() {
    return getMaxZoomForMinDpi(MIN_PRINT_DPI);
}

function clampZoomByDpi(newZoom, minDpi = MIN_PRINT_DPI) {
    const boundedZoom = Math.max(appState.minZoom, Math.min(appState.maxZoom, newZoom));
    const dpiLimitedMaxZoom = getMaxZoomForMinDpi(minDpi);
    return Math.max(appState.minZoom, Math.min(boundedZoom, dpiLimitedMaxZoom));
}

function isAtDynamicMaxZoom(epsilon = 0.0001) {
    const currentZoom = getCurrentImageZoom();
    const dynamicMax = getDynamicMaxZoom();
    return currentZoom >= (dynamicMax - epsilon);
}

function getZoomLimitToastElement() {
    if (zoomLimitToastEl) return zoomLimitToastEl;

    const el = document.createElement("div");
    el.id = "zoom-limit-toast";
    el.style.cssText = `
        position: fixed;
    left: 50%;
    bottom: 130px;
    transform: translateX(-50%);
    background: rgba(20, 20, 20, 1);
    color: #fff;
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 8px;
    z-index: 9999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.15);
    white-space: nowrap;
    `;
    el.textContent = "You reach max zoom image resolution";
    document.body.appendChild(el);
    zoomLimitToastEl = el;
    return el;
}

function showZoomLimitMessage() {
    const toast = getZoomLimitToastElement();
    toast.style.opacity = "1";

    if (zoomLimitToastTimer) {
        clearTimeout(zoomLimitToastTimer);
    }

    zoomLimitToastTimer = setTimeout(() => {
        toast.style.opacity = "0";
        zoomLimitToastTimer = null;
    }, 1200);
}

function updateZoomControlsState() {
    const slider = document.getElementById("zoomSlider");
    const zoomInBtn = document.getElementById("zoomIn");
    const dynamicMaxZoom = getDynamicMaxZoom();

    if (slider) {
        slider.min = String(appState.minZoom * 100);
        slider.max = String(Math.round(dynamicMaxZoom * 100));
        slider.value = String(Math.round(getCurrentImageZoom() * 100));
        updateSliderBackground(slider);
    }

    if (zoomInBtn) {
        if (isAtDynamicMaxZoom()) {
            zoomInBtn.style.opacity = "0.5";
            zoomInBtn.style.cursor = "not-allowed";
        } else {
            zoomInBtn.style.opacity = "1";
            zoomInBtn.style.cursor = "pointer";
        }
    }
}

function enforceMinimumDpi(minDpi = MIN_PRINT_DPI) {
    if (!appState.uploadedImage) return false;

    const currentZoom = getCurrentImageZoom();
    const targetZoom = clampZoomByDpi(currentZoom, minDpi);

    if (!isFinite(targetZoom) || targetZoom <= 0) return false;
    if (targetZoom >= (currentZoom - 0.000001)) return false;

    updateZoom(targetZoom);
    updatePositionInfo();
    syncZoomSlider();
    updateZoomControlsState();
    return true;
}

function isZoomAllowed(newZoom) {
    const requested = Math.max(appState.minZoom, Math.min(appState.maxZoom, newZoom));
    const allowed = clampZoomByDpi(requested, MIN_PRINT_DPI);
    return allowed >= (requested - 0.000001);
}

function initZoomSlider() {
    const slider = document.getElementById("zoomSlider");
    if (!slider) return;
    slider.min = String(appState.minZoom * 100);
    slider.max = String(Math.round(getDynamicMaxZoom() * 100));
    slider.value = String(appState.zoom * 100);
    updateSliderBackground(slider);
    syncZoomSlider();
}


document.addEventListener("DOMContentLoaded", function () {
    initZoomSlider();
    const slider = document.getElementById("zoomSlider");
    if (slider && slider.dataset.zoomBound !== "1") {
        slider.addEventListener("input", function () {
            handleZoomSlider(this);
        });
        slider.dataset.zoomBound = "1";
    }

    // zoom button click handlers are bound once above.
});

function calculateCoverZoom() {
    if (!appState.uploadedImage) {
        return 1;
    }

    const img = appState.uploadedImage;
    const imgElement = img._element;
    if (!imgElement) {
        return 1;
    }

    const canvasWidth = appState.selectedWidth;
    const canvasHeight = appState.selectedHeight;
    const W = img.width;
    const H = img.height;

    const scaleX = appState.innerWidth / W;
    const scaleY = appState.innerHeight / H;

    let newScale = Math.max(scaleX, scaleY);
    if (!isFinite(newScale) || newScale <= 0) newScale = 1;

    img.scaleX = newScale;
    img.scaleY = newScale;
    appState.scaleFactor = newScale;

    const centerX = canvasWidth / 2;
    const centerY = canvasHeight / 2;
    const fitScale = Math.max(scaleX, scaleY);
    const finalZoom = Math.min(1, fitScale);

    return finalZoom;
}

function getBaseScale() {
    if (!appState.uploadedImage) return 1;

    const img = appState.uploadedImage;
    const canvasWidth = appState.selectedWidth;
    const canvasHeight = appState.selectedHeight;

    const scaleX = canvasWidth / img.width;
    const scaleY = canvasHeight / img.height;

    return Math.min(scaleX, scaleY);
}


function updateZoom(newZoom) {
    if (!appState.uploadedImage) {
        console.warn("No uploaded image to zoom");
        return;
    }

    try {
        const baseScale = getBaseScale();
        const requestedZoom = Math.max(appState.minZoom, Math.min(appState.maxZoom, newZoom));
        const dpiMaxZoom = getDynamicMaxZoom();
        newZoom = clampZoomByDpi(requestedZoom, MIN_PRINT_DPI);
        appState.zoom = newZoom;

        if (baseScale <= 0 || !isFinite(baseScale)) {
            console.warn("Invalid base scale for zoom:", baseScale);
            return;
        }

        const finalScale = baseScale * appState.zoom;

        appState.uploadedImage.scaleX = finalScale;
        appState.uploadedImage.scaleY = finalScale;
        appState.scaleFactor = finalScale;

        updateMovementConstraints();
        centerImage();
        appState.uploadedImage.setCoords();
        updatePositionInfo();

        const slider = document.getElementById("zoomSlider");
        if (slider) {
            slider.value = String(Math.round(appState.zoom * 100));
            updateSliderBackground(slider);
        }

        updateZoomLabel();
        updateZoomControlsState();
        canvas.requestRenderAll();
        return {
            requestedZoom,
            appliedZoom: newZoom,
            dpiMaxZoom,
            hitLimit: requestedZoom > (newZoom + 0.000001)
        };
    } catch (error) {
        console.error("Error in updateZoom:", error);
        return {
            requestedZoom: newZoom,
            appliedZoom: appState.zoom,
            dpiMaxZoom: getDynamicMaxZoom(),
            hitLimit: false
        };
    }
}

function updateZoomLabel() {
    const zoomLabel = document.getElementById("zoomLabel");
    if (zoomLabel) {
        zoomLabel.textContent = `${Math.round(appState.zoom * 100)}%`;
    }
}

function syncZoomSlider() {
    const slider = document.getElementById("zoomSlider");
    if (!slider || !appState.uploadedImage) return;

    try {
        // Calculate current zoom based on image scale
        const baseScale = getBaseScale();

        if (baseScale <= 0 || !isFinite(baseScale)) {
            console.warn("Invalid base scale:", baseScale);
            return;
        }

        const currentZoom = appState.uploadedImage.scaleX / baseScale;

        // Update appState.zoom with proper bounds
        appState.zoom = Math.max(
            appState.minZoom,
            Math.min(getDynamicMaxZoom(), currentZoom)
        );

        // Update slider
        slider.min = String(appState.minZoom * 100);
        slider.max = String(Math.round(getDynamicMaxZoom() * 100));
        slider.value = String(Math.round(appState.zoom * 100));

        updateSliderBackground(slider);
        updateZoomLabel();
        updateZoomControlsState();
    } catch (error) {
        console.error("Error in syncZoomSlider:", error);
    }
}



function handleZoomSlider(slider) {
    if (!appState.uploadedImage) return;

    try {

        const zoomValue = Number(slider.value) / 100;
        const result = updateZoom(zoomValue);
        const currentMax = Number(slider.max);
        const isSliderAtMax = Number(slider.value) >= currentMax;
        if ((result && result.hitLimit) || isSliderAtMax) {
            showZoomLimitMessage();
        }
        updateSliderBackground(slider);
    } catch (error) {
        console.error("Error in handleZoomSlider:", error);
    }
}


function setZoomToCover() {
    if (!appState.uploadedImage) return;

    const img = appState.uploadedImage;
    const canvasWidth = appState.selectedWidth;
    const canvasHeight = appState.selectedHeight;

    // Calculate cover scale (fills the frame)
    const scaleX = canvasWidth / img.width;
    const scaleY = canvasHeight / img.height;
    const coverScale = Math.max(scaleX, scaleY);

    // Calculate zoom level based on cover scale
    const baseScale = getBaseScale();
    const coverZoom = coverScale / baseScale;

    // Apply zoom
    updateZoom(coverZoom);
}
function setZoomToFit() {
    if (!appState.uploadedImage) return;

    const img = appState.uploadedImage;
    const canvasWidth = appState.selectedWidth;
    const canvasHeight = appState.selectedHeight;

    // Calculate fit scale (fits within frame)
    const scaleX = canvasWidth / img.width;
    const scaleY = canvasHeight / img.height;
    const fitScale = Math.min(scaleX, scaleY);

    // Calculate zoom level based on fit scale
    const baseScale = getBaseScale();
    const fitZoom = fitScale / baseScale;

    // Apply zoom (100% = fit to frame)
    updateZoom(fitZoom);
}

document.addEventListener("DOMContentLoaded", function () {
    const edgesCheckbox = document.getElementById("enable-edges");
    if (edgesCheckbox) {
        edgesCheckbox.addEventListener("change", function () {
            if (appState.uploadedImage) {
                handleZoomSlider(document.getElementById("zoomSlider"));
            }
        });
    }
});

function zoomIn() {
    if (!appState.uploadedImage) return;

    const newZoom = appState.zoom * 1.1;
    const result = updateZoom(newZoom);
    const atMax = isAtDynamicMaxZoom();
    if ((result && result.hitLimit) || atMax) {
        showZoomLimitMessage();
    }
}

function zoomOut() {
    if (!appState.uploadedImage) return;

    // Decrease zoom by 10%
    const newZoom = appState.zoom * 0.9;
    updateZoom(newZoom);
}

function resetZoom() {
    // Reset to 100% zoom (fit to frame)
    updateZoom(1.0);
}


if (slider && slider.dataset.zoomBound !== "1") {
    handleZoomSlider(slider);
    slider.addEventListener("input", () => handleZoomSlider(slider));
    slider.dataset.zoomBound = "1";
}

// zoomInBtn.addEventListener("click", () => updateZoom(appState.zoom + 1));
// zoomOutBtn.addEventListener("click", () => updateZoom(appState.zoom - 1));

window.addEventListener("DOMContentLoaded", () => {
    const params = new URLSearchParams(window.location.search);
    const toolParam = params.get("tool");
    const syncmodeparam = params.get("syncMode");

    const firstSelected = document.querySelector("#frameSizeOptions input[name=\"frameSize\"]:checked") || document.querySelector("#frameSizeOptions input[name=\"frameSize\"]");

    if (firstSelected) {
        const [width, height] = firstSelected.getAttribute("data-size").split("x").map(Number);
        appState.selectedWidth = width;
        appState.selectedHeight = height;
        updateFrameFromPixels(appState.selectedWidth, appState.selectedHeight);
    }
    if (syncmodeparam === "select-pdp" || syncmodeparam === "select-print" || syncmodeparam === "pdp-select" || syncmodeparam === "pdp-img") {
        let sessionImageData1;
        let shouldDisableSizes = false;
        let pdpSelectTag;
        if (syncmodeparam === "select-pdp") {
            sessionImageData1 = getLocalStorage1Day("pdp-select-img");
            pdpSelectTag = getLocalStorage1Day("select-tags");
        } else if (syncmodeparam === "select-print") {
            sessionImageData1 = getLocalStorage1Day("select-print-image");
            pdpSelectTag = getLocalStorage1Day("select-tags");
        } else if (syncmodeparam === "pdp-img") {
            sessionImageData1 = getLocalStorage1Day("pdpUploadedImage");
        } else if (syncmodeparam === "pdp-select") {
            sessionImageData1 = getLocalStorage1Day("frame-select-img");
        }


        if (pdpSelectTag) {
            try {
                const tags = JSON.parse(pdpSelectTag);
                shouldDisableSizes = tags.includes("style-image") || tags.includes("edit-image");
            } catch (e) {
                console.error(e);
            }
        }

        const disableFrameSizes = [
      '30″×40″',
      '20″×60″',
      '32″×48″',
      '40″×60″',
      '40″×55″',
      '20″×40″',
      '24″×48″',
      '32″×32″',
      '36″×36″',
      '37″×37″'
    ];


        if (shouldDisableSizes) {

            document.querySelectorAll('#frameSizeOptions input[name="frameSize"]').forEach(input => {

                const frameSize = input.getAttribute("data-frmsize");

                if (disableFrameSizes.includes(frameSize)) {

                    input.disabled = true;

                    const label = input.closest(".frame-size-btn");

                    if (label) {
                        label.style.pointerEvents = "none";
                        label.style.opacity = "0.5";
                        label.style.cursor = "not-allowed";
                    }

                }

            });

        }
        if (sessionImageData1) {
            showCanvasOpsLoader();
            galleryWrapper.style.display = "none";
            uploadInputwrap.style.display = "none";
            customForm.style.display = "block";

            const mainImgWrap = document.querySelector(".main-img-wrap");
            if (mainImgWrap) {
                mainImgWrap.setAttribute("data-main-img", sessionImageData1);
            }

            const tempImg = new Image();
            tempImg.onload = function () {

                const imgfileWElement = document.getElementById("img-file-w");
                const imgfileHElement = document.getElementById("img-file-h");

                if (imgfileWElement) imgfileWElement.textContent = tempImg.width;
                if (imgfileHElement) imgfileHElement.textContent = tempImg.height;

                fabric.Image.fromURL(sessionImageData1, async function (img) {
                    appState.uploadedImage = img;
                    appState.uploadedImage.set({
                        selectable: true,
                        hasBorders: false,
                        hasControls: false,
                        lockRotation: true,
                        lockScalingFlip: true,
                        lockUniScaling: true,
                        originX: "center",
                        originY: "center",
                        clipPath: appState.clipPath,
                    });

                    canvas.add(appState.uploadedImage);
                    setMovementConstraints();
                    canvas.setActiveObject(appState.uploadedImage);
                    canvas.moveTo(appState.uploadedImage, 2);
                    fitImageToFrame(false);

                    // Sync zoom slider after loading image
                    syncZoomSlider();
                    await waitForCanvasRenderComplete();
                    hideCanvasOpsLoader();
                });
                document.querySelectorAll(".image-conform-btn").forEach(div => {
                    div.style.pointerEvents = "auto";
                    div.style.opacity = "1";
                });
            };
            tempImg.onerror = function () {
                hideCanvasOpsLoader();
            };
            tempImg.src = sessionImageData1;
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {
    function updateVariantId() {
        const size = document.querySelector("input[name=\"frameSize\"]:checked")?.value;

        if (!size) return;

        const variant = window.productVariants.find(
            (v) => v.option1 === size
        );
        if (variant) {
            const variantInput = document.querySelector("input[name=\"id\"]");
            if (variantInput) {
                variantInput.value = variant.id;
            }

            const variantInputSize = document.querySelector("input[name=\"properties[_pdp-size]\"]");
            if (variantInputSize) {
                variantInputSize.value = variant.option1;
            }

            const variantInputId = document.querySelector("input[name=\"properties[_pdp-variant-id]\"]");
            if (variantInputId) {
                variantInputId.value = variant.sku;
            }

            let numericPrice = null;
            let numericCmpPrice = null;


            // Base price
            if (typeof variant.price === "number") {
                numericPrice = variant.price / 100;
            } else if (variant.price?.amount) {
                numericPrice = parseFloat(variant.price.amount);
            } else if (variant.priceV2?.amount) {
                numericPrice = parseFloat(variant.priceV2.amount);
            }

            let finalPrice = numericPrice;
            if (Number.isFinite(numericPrice) && window.isPremiumCustomer === true) {
                finalPrice = numericPrice * 0.9; // 10% OFF
            }


            const priceElement = document.querySelector("#price-sale-text");
            if (priceElement) {
                priceElement.textContent = Number.isFinite(finalPrice)
                    ? `$${finalPrice.toFixed(2)}`
                    : "";
            }
            const priceElement1 = document.querySelector(".main-price");
            if (priceElement1) {
                priceElement1.textContent = Number.isFinite(finalPrice)
                    ? `$${finalPrice.toFixed(2)}`
                    : "";
            }

            if (typeof variant.compare_at_price === "number") {
                numericCmpPrice = variant.compare_at_price / 100;
            } else if (variant.compare_at_price?.amount) {
                numericCmpPrice = parseFloat(variant.compare_at_price.amount);
            } else if (variant.compare_at_priceV2?.amount) {
                numericCmpPrice = parseFloat(variant.compare_at_priceV2.amount);
            }

            const cmppriceElement = document.querySelector("#compare-price-text");
            if (cmppriceElement) {
                cmppriceElement.textContent = Number.isFinite(numericCmpPrice)
                    ? `$${numericCmpPrice.toFixed(2)}`
                    : "";
            }

            const cmppriceElement1 = document.querySelector(".compare-price");
            if (cmppriceElement1) {
                cmppriceElement1.textContent = Number.isFinite(numericCmpPrice)
                    ? `$${numericCmpPrice.toFixed(2)}`
                    : "";
            }

            const savePrElement = document.querySelector("#save-pr-text");
            if (savePrElement) {
                if (
                    Number.isFinite(finalPrice) &&
                    Number.isFinite(numericCmpPrice) &&
                    numericCmpPrice > finalPrice
                ) {
                    const discountPercent = Math.round(
                        ((numericCmpPrice - finalPrice) / numericCmpPrice) * 100
                    );
                    savePrElement.textContent = `${discountPercent}%`;
                    savePrElement.style.display = "";
                } else {
                    savePrElement.textContent = "";
                    savePrElement.style.display = "none";
                }
            }
            const savePrElement1 = document.querySelector(".save-percentage");
            if (savePrElement1) {
                if (
                    Number.isFinite(finalPrice) &&
                    Number.isFinite(numericCmpPrice) &&
                    numericCmpPrice > finalPrice
                ) {
                    const discountPercent = Math.round(
                        ((numericCmpPrice - finalPrice) / numericCmpPrice) * 100
                    );
                    savePrElement1.textContent = `Save ${discountPercent}%`;
                    savePrElement1.style.display = "";
                } else {
                    savePrElement1.textContent = "";
                    savePrElement1.style.display = "none";
                }
            }

            logAllAddedElements();

            const productImage = document.querySelector(".image-magnify-lightbox");
            if (productImage && variant.image) {
                const imageUrl = typeof variant.image === "string" ? variant.image : variant.image.src;

                productImage.src = imageUrl;

                const widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
                productImage.srcset = widths.map(w => `${imageUrl}?width=${w} ${w}w`).join(", ");
                productImage.alt = variant.image.alt || `${variant.option1}`;
            }
        } else {
            console.warn("No variant matched the selected size:", size);
        }
    }

    document.querySelectorAll("input[name=\"frameSize\"], input[name=\"frameColor\"]").forEach((input) => {
        input.addEventListener("change", updateVariantId);
    });

    updateVariantId();
});

document.querySelectorAll(".image-conform-btn").forEach(btn => {
    btn.addEventListener("click", function (e) {

        sendMainImageToAPI(e);
    });
});

async function sendMainImageToAPI(e) {
    console.log("sendMainImageToAPI() triggered");

    // Get edge type from hidden input
    const edgeTypeInput = document.getElementById("final-image-type-data");
    const edgeType = edgeTypeInput ? edgeTypeInput.value : "FitToEdge";
    console.log("Edge type detected:", edgeType);

    // Show popups
    const finalpopup = document.querySelector(".finalize-image-popup");
    if (finalpopup) finalpopup.style.display = "none";

    const finalpopup1 = document.querySelector("#is-first");
    if (finalpopup1) finalpopup1.style.display = "none";

    const finalpopup2 = document.querySelector("#is-second");
    if (finalpopup2) finalpopup2.style.display = "none";

    const btn = e.currentTarget;
    btn.textContent = "Adding...";
    btn.disabled = true;

    try {
        if (edgeType === "FitToEdge") {
            console.log("Running FIT TO EDGE flow...");

            const mainImgWrap = document.querySelector(".main-img-wrap");
            if (!mainImgWrap) throw new Error("No .main-img-wrap element found");

            const imageData = mainImgWrap.getAttribute("data-main-img");
            if (!imageData) throw new Error("No image data found");

            function base64ToBlob(base64) {
                const byteString = atob(base64.split(",")[1]);
                const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
                return new Blob([ab], { type: mimeString });
            }

            const formData = new FormData();
            const userId = window.shopifyCustomerId || "guest";
            const sessionId = getLocalStorage1Day("sessionId") || "none";

            if (imageData.startsWith("http") || imageData.startsWith("//")) {
                formData.append("imageUrl", imageData);
            } else if (imageData.startsWith("data:image/")) {
                const imageBlob = base64ToBlob(imageData);
                formData.append("file", imageBlob, "uploaded-image.jpeg");
            } else {
                throw new Error("Invalid image data format");
            }

            formData.append("customerId", userId);
            formData.append("sessionId", sessionId);

            console.log("Uploading image to API...");
            const response = await fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
                method: "POST",
                headers: {
                    "x-api-key": window.Prompt2Prints.apiKey
                },
                body: formData,
            });
            const data = await response.json();
            const imageUpscale = document.querySelector('input[name="properties[_pdp-allow-upscale]"]');
            const imageUpscaletag = document.querySelector('input[name="properties[_pdp-img-tag]"]');

            if (!imageUpscale || !imageUpscaletag) {
                console.warn("Upscale inputs not found");
                return;
            }

            const flag = (data.flag || "").toLowerCase();

            if (flag === "standard") {
                imageUpscale.value = "true";
                imageUpscaletag.value = "Standard";
            }
            else if (flag === "professional") {
                imageUpscale.value = "false";
                imageUpscaletag.value = "Professional";
            }
            else {
                imageUpscale.value = "";
                imageUpscaletag.value = "";
            }

            // Optional: also update attribute for Shopify forms
            imageUpscale.setAttribute("value", imageUpscale.value);
            imageUpscaletag.setAttribute("value", imageUpscaletag.value);
            const cvswElement = parseFloat(document.getElementById("cvs-w")?.textContent) || 0;
            const cvswFinalElement = appState.finalw || 0;
            const cvshFinalElement = appState.finalh || 0;
            const cvstElement = appState.finalt || 0;
            const cvslElement = appState.finall || 0;
            const cvshElement = parseFloat(document.getElementById("cvs-h")?.textContent) || 0;
            const hiddenimg = document.getElementById("frame-img-position");
            const orientationRadio = document.querySelector('input[name="orientation"]:checked');
            const orientation = orientationRadio ? orientationRadio.value : "portrait";
            if (orientation == "portrait") {
                if (hiddenimg) {
                    hiddenimg.value = JSON.stringify({
                        area_width: cvswElement,
                        area_height: cvshElement,
                        width: cvswFinalElement,
                        height: cvshFinalElement,
                        top: cvstElement,
                        left: cvslElement,
                    });
                }
            }
            else if (orientation == "landscape") {
                if (hiddenimg) {
                    hiddenimg.value = JSON.stringify({
                        area_width: cvswElement,
                        area_height: cvshElement,
                        width: cvswFinalElement,
                        height: cvshFinalElement,
                        top: cvstElement,
                        left: cvslElement,
                    });
                }
            }
            const hiddenInput = document.getElementById("final-image-data");
            if (hiddenInput && data.cloudfrontLink) {
                hiddenInput.value = data.cloudfrontLink;
                console.log("Saved CloudFront link:", data.cloudfrontLink);
            }

            // Export full div as image and WAIT for it to complete
            console.log("Starting exportFullDivAsImage...");
            await exportFullDivAsImage(userId, sessionId);
            console.log("FIT TO EDGE export completed");

            // These will only run after exportFullDivAsImage is completely finished
            if (finalpopup1) finalpopup1.style.display = "none";
            if (finalpopup2) finalpopup2.style.display = "none";

            btn.textContent = "Added!";
            const customForm = document.getElementById('custom-image-form');
            customForm.submit();
            return;
        }


    } catch (error) {
        console.error("ERROR in sendMainImageToAPI:", error);
        btn.textContent = "Failed. Try again";
    } finally {
        btn.disabled = false;
        console.log("Button re-enabled");
    }
}
async function urlToBase64(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "https://prompt2prints.com";
        img.onload = () => {
            const canvasEl = document.createElement("canvas");
            canvasEl.width = img.width;
            canvasEl.height = img.height;
            const ctx = canvasEl.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvasEl.toDataURL("image/jpeg"));
        };
        img.onerror = reject;
        img.src = url;
    });
}

window.addedElements = [];

window.logAllAddedElements = function () {
    window.addedElements.forEach((el, index) => {
        // Log elements if needed
    });
};

window.removeSelectedElements = function (indices) {
    indices.sort((a, b) => b - a);

    indices.forEach((i) => {
        if (window.addedElements[i]) {
            canvas.remove(window.addedElements[i]);
            window.addedElements.splice(i, 1);
        }
    });
};

async function reloadImageAsBase64(img) {
    if (!img._element || !img._element.src || img._element.src.startsWith("data:")) return img;

    const src = img._element.src;
    const left = img.left;
    const top = img.top;
    const scaleX = img.scaleX;
    const scaleY = img.scaleY;
    const angle = img.angle;
    const originX = img.originX;
    const originY = img.originY;

    const base64 = await urlToBase64(src);

    return new Promise((resolve) => {
        fabric.Image.fromURL(base64, (newImg) => {
            newImg.set({ left, top, scaleX, scaleY, angle, originX, originY });
            // 🔴 REMOVE CENTER GUIDE LINES
            canvas.getObjects('line').forEach((obj) => {
                if (obj.stroke === 'red' && obj.opacity === 0.5) {
                    canvas.remove(obj);
                }
            });

            // Remove old image
            canvas.remove(img);
            canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

            // Add new image and track it
            canvas.add(newImg);
            window.addedElements.push(newImg);

            let innerPadding = 0;
            // track border

            resolve(newImg);
            logAllAddedElements();
        }, {
            crossOrigin: "anonymous"
        });
    });
}

async function exportFullDivAsImage(customerId, sessionId) {
    const parentDiv = document.querySelector(".back-image");
    if (!parentDiv) {
        console.error("No element with class .back-image found");
        return;
    }

    if (typeof canvas === "undefined") {
        console.error("Fabric.js canvas not defined");
        return;
    }

    canvas.discardActiveObject();
    canvas.getObjects().forEach(obj => obj.set({
        selectable: false,
        evented: false
    }));

    canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

    canvas.renderAll();

    try {
        const images = canvas.getObjects("image");
        await Promise.all(images.map(img => reloadImageAsBase64(img)));


        // 1️⃣ Export canvas to data URL
        const dataURL = canvas.toDataURL({
            format: "jpeg",
            multiplier: 2,
        });

        const paddedDataURL = await addPaddingToDataURL(dataURL, 50);
        const res = await fetch(paddedDataURL);
        const blob = await res.blob();

        const formData = new FormData();
        formData.append("file", blob, "full-div-image.jpeg");
        formData.append("customerId", customerId);
        formData.append("sessionId", sessionId);
        formData.append("thumbnailWidth", "200");

        const response = await fetch(`${window.Prompt2Prints.apiBase}/image-thumbnail`, {
            method: "POST",
            headers: {
                "x-api-key": window.Prompt2Prints.apiKey
            },
            body: formData,
        });

        const data = await response.json();

        const hiddenInput = document.getElementById("preview-image-data");
        if (hiddenInput && data.original?.cloudfrontUrl) hiddenInput.value = data.original.cloudfrontUrl;

        const hiddenInput1 = document.getElementById("preview-thumb-image-data");
        if (hiddenInput1 && data.thumbnail?.cloudfrontUrl) hiddenInput1.value = data.thumbnail.cloudfrontUrl;

        // Optional: display padded image in .full-content
        let fullContentDiv = document.querySelector(".full-content");
        if (!fullContentDiv) {
            fullContentDiv = document.createElement("div");
            fullContentDiv.className = "full-content";
            document.body.appendChild(fullContentDiv);
        }
        fullContentDiv.innerHTML = "";
        const imgElement = document.createElement("img");
        imgElement.src = paddedDataURL;
        fullContentDiv.appendChild(imgElement);
        removeSelectedElements([1, 2, 3]);

    } catch (err) {
        console.error("Error exporting full div:", err);
    } finally {
        canvas.getObjects().forEach(obj => obj.set({
            selectable: true,
            evented: true
        }));
        canvas.renderAll();
    }
}

// Helper function: add padding to a dataURL
function addPaddingToDataURL(dataURL, padding) {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = dataURL;
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width + padding * 2;
            canvas.height = img.height + padding * 2;
            const ctx = canvas.getContext("2d");

            ctx.fillStyle = "#000000";

            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw original image in center
            ctx.drawImage(img, padding, padding);

            resolve(canvas.toDataURL("image/jpeg"));
        };
    });
}

function captureImageTransform(image) {
    if (!image) return null;

    return {
        left: image.left,
        top: image.top,
        angle: image.angle,
        originX: image.originX || "left",
        originY: image.originY || "top",

        // ✅ visible size in canvas px
        visibleWidth: image.getScaledWidth(),
        visibleHeight: image.getScaledHeight()
    };
}


function applyImageTransform(image, transform) {
    if (!image || !transform) return;

    const scaleX = transform.visibleWidth / image.width;
    const scaleY = transform.visibleHeight / image.height;

    image.set({
        left: transform.left,
        top: transform.top,
        angle: transform.angle,
        originX: transform.originX,
        originY: transform.originY,
        scaleX,
        scaleY
    });

    image.setCoords();
}

async function upscaleAndFixDPI({
    sessionId = "none",
    customerId = "guest",
    dpi = null,
    printHeight = null,
    printWidth = null,
    imageUrl = null,
    file = null,
    callback = null // Add callback parameter
}) {
    const savepopup = document.querySelector(".save-image-popup");
    const afterSavePopup = document.querySelector("#aftersavepopup"); // Get the after save popup

    if (savepopup) savepopup.style.display = "flex";
    if (afterSavePopup) afterSavePopup.style.display = "none"; // Ensure it's hidden initially


    const savepopuptitle = document.querySelector(".save-image-title");
    const savepopupicon = document.querySelector(".save-image-icon");
    const savepopuptext = document.querySelector(".save-image-text");

    if (savepopupicon) savepopupicon.style.display = "flex";

    savepopuptitle.textContent = "Boosting Image";
    savepopuptext.textContent = "Boosting resolution for maximum clarity";

    // 🔹 SAVE CURRENT IMAGE TRANSFORM
    const previousTransform = captureImageTransform(appState.uploadedImage);

    const imagefinalWidth = (appState.imageWidth * 300) / appState.dpi;
    const imagefinalHeight = (appState.imageheight * 300) / appState.dpi;

    const formData = new FormData();
    formData.append("sessionId", sessionId);
    formData.append("customerId", customerId);
    if (dpi) formData.append("dpi", dpi);
    if (printWidth) formData.append("printWidth", printWidth);
    if (printHeight) formData.append("printHeight", printHeight);
    formData.append("format", "jpeg");
    formData.append("faceEnhancement", "true");
    formData.append("finalWidth", imagefinalWidth);
    formData.append("finalHeight", imagefinalHeight);
    const currentPageUrl = window.location.href;
    formData.append("page_url", currentPageUrl);
    if (imageUrl) formData.append("imageUrl", imageUrl);
    if (file) {
        formData.append("file", file);
        formData.append("isDirectUpload", "true");
    }
    try {
        const response = await fetch(`${window.Prompt2Prints.apiBase}/boost-image`, {
            method: "POST",
            headers: {
                "x-api-key": window.Prompt2Prints.apiKey
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const result = await response.json();
        if (result?.error) {
            throw new Error(result.error);
        }

        const enhancedUrl = result?.enhanced;
        if (!enhancedUrl) {
            throw new Error("No enhanced URL returned");
        }

        const mainImgWrap = document.querySelector(".main-img-wrap");
        if (mainImgWrap) {
            mainImgWrap.setAttribute("data-main-img", enhancedUrl);
            mainImgWrap.innerHTML = `<img src="${enhancedUrl}" style="max-width:100%;">`;
        }

        fabric.Image.fromURL(enhancedUrl, async (img) => {

            canvas.clear();
            // set white background
            canvas.setBackgroundColor('#ffffff', canvas.renderAll.bind(canvas));
            appState.uploadedImage = img;
            appState.uploadedImage.set({
                selectable: true,
                hasBorders: false,
                hasControls: false,
                lockRotation: true,
                lockScalingFlip: true,
                lockUniScaling: true,
                originX: "center",
                originY: "center",
                clipPath: appState.clipPath || null,
            });
            canvas.add(appState.uploadedImage);

            // 🔹 RESTORE EXACT SAME POSITION
            if (previousTransform) {
                applyImageTransform(appState.uploadedImage, previousTransform);
            } else {
                canvas.centerObject(appState.uploadedImage);
            }

            setMovementConstraints();
            canvas.setActiveObject(appState.uploadedImage);
            canvas.renderAll();

            // fitImageToFrame(true);

            document.getElementById("img-file-w").textContent =
                appState.uploadedImage.width || 0;
            document.getElementById("img-file-h").textContent =
                appState.uploadedImage.height || 0;

            await updatePositionInfo();

            const slider = document.getElementById("zoomSlider");
            if (slider) {
                updateSliderBackground(slider);
                syncZoomSlider(); // Sync zoom slider after upscale
            }


            // 🔹 Inline DPI display logic
            // const dpiElement = document.querySelector(".dpi-num");
            // const iconElement = document.querySelector(".dpi-state-icon");
            const boostBtn = document.querySelector(".boost-img-btn");
            const currentDpi = Number((appState.dpi || 0).toFixed(2));

            if (boostBtn) {

                //  iconElement.innerHTML = ""; // clear old icon

                if (currentDpi < 30) {
                    //          dpiElement.textContent = `Needs Upscale`;
                    //           dpiElement.style.color = "red";

                    //           iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    // <path d="M9.9891 0C4.49317 0 0 4.49317 0 9.9891C0 15.4859 4.49317 20 9.9891 20C15.485 20 20 15.5068 20 9.9891C20 4.47115 15.5068 0 9.9891 0ZM9.9891 18.3208C5.40912 18.3208 1.67946 14.5911 1.67946 10.0111C1.67946 5.43115 5.40912 1.70148 9.9891 1.70148C14.5691 1.70148 18.2987 5.43115 18.2987 10.0111C18.3207 14.5911 14.5909 18.3208 9.9891 18.3208Z" fill="#FF0606"/>
                    // <path d="M10.1207 4.56252C9.74952 4.56252 9.44421 4.69326 9.20466 4.93365C8.98621 5.1732 8.85547 5.52239 8.85547 5.93651C8.85547 6.24185 8.8774 6.72177 8.92126 7.41931L9.16081 10.9307C9.20466 11.4106 9.29154 11.7379 9.37926 11.9774C9.48806 12.2389 9.70651 12.3696 10.0118 12.3696C10.3172 12.3696 10.5137 12.2389 10.6444 11.9774C10.7532 11.7379 10.841 11.3887 10.8629 10.9526L11.1682 7.33156C11.2121 7.0043 11.2121 6.65511 11.2121 6.34977C11.2121 5.78297 11.1463 5.34691 10.9936 5.04073C10.884 4.7371 10.5787 4.56252 10.1207 4.56252Z" fill="#FF0606"/>
                    // <path d="M10.0549 13.4844C9.72761 13.4844 9.44421 13.5932 9.20466 13.8336C8.96511 14.0731 8.85547 14.3354 8.85547 14.6627C8.85547 15.0338 8.9862 15.3391 9.2266 15.5348C9.46615 15.7313 9.75039 15.8402 10.0768 15.8402C10.3821 15.8402 10.6655 15.7313 10.9059 15.5129C11.1455 15.2944 11.277 14.6408 11.277 14.6408C11.277 14.3135 11.1682 14.0301 10.9278 13.7906C10.6655 13.5932 10.3813 13.4844 10.0549 13.4844Z" fill="#FF0606"/>
                    // </svg>`;

                    boostBtn.style.display = "flex";
                    boostBtn.classList.add("show")

                } else {
                    //        dpiElement.textContent = `Good To Print`;
                    //           dpiElement.style.color = "green";

                    //           iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    // <path d="M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 17.8105C5.68421 17.8105 2.18947 14.2947 2.18947 10C2.18947 5.70526 5.68421 2.18947 10 2.18947C14.3158 2.18947 17.8105 5.68421 17.8105 10C17.8105 14.3158 14.3158 17.8105 10 17.8105Z" fill="#1B8600"/>
                    // <path d="M12.7139 6.92258L8.90337 10.7542L7.28232 9.13311C6.86127 8.71205 6.16653 8.71205 5.74548 9.13311C5.32442 9.55416 5.32442 10.2489 5.74548 10.6699L8.14548 13.0699C8.356 13.2805 8.62969 13.3857 8.92443 13.3857C9.21916 13.3857 9.49285 13.2805 9.70337 13.0699L14.2928 8.48047C14.7139 8.05942 14.7139 7.36469 14.2928 6.94363C13.8507 6.50153 13.156 6.50153 12.7139 6.92258Z" fill="#1B8600"/>
                    // </svg>`;

                    boostBtn.classList.remove("show");
                    if (!boostBtn.classList.contains("show")) boostBtn.style.display = "none";

                }
            }

        });

        if (
            result?.message ===
            "We can not upscale this image further. Please try a different image."
        ) {
            console.log(result.message);
            if (savepopup) savepopup.style.display = "flex";
            const savepopuptitle = document.querySelector(".save-image-title");
            const savepopupicon = document.querySelector(".save-image-icon");
            const savepopuptext = document.querySelector(".save-image-text");
            const boostBtns = document.querySelectorAll(".boost-img-btn");

            boostBtns.forEach(btn => {
                btn.classList.add("limit-reached");
            });
            if (savepopupicon) savepopupicon.style.display = "none";

            if (result?.message === "We can not upscale this image further. Please try a different image.") {
                savepopuptitle.textContent = "Change Image";
                savepopuptext.textContent =
                    "The image has reached its maximum resolution and cannot be upscaled further.";
            }

            setTimeout(() => {
                if (savepopup) savepopup.style.display = "none";
            }, 3000);
        } else {
            // Show aftersave popup and hide savepopup after delay
            if (savepopup) savepopup.style.display = "none";

            if (afterSavePopup) {
                afterSavePopup.style.display = "flex";

                // Hide aftersave popup after 3-4 seconds
                setTimeout(() => {
                    afterSavePopup.style.display = "none";
                }, 3500); // 3.5 seconds
            }
        }


    } catch (err) {
        console.error("Upscale API failed:", err);
        if (savepopup) savepopup.style.display = "flex";

        const savepopuptitle = document.querySelector(".save-image-title");
        const savepopupicon = document.querySelector(".save-image-icon");
        const savepopuptext = document.querySelector(".save-image-text");

        if (savepopupicon) savepopupicon.style.display = "none";

        if (err.message === "We can not upscale this image further. Please try a different image.") {
            savepopuptitle.textContent = "Change Image";
            savepopuptext.textContent =
                "The image has reached its maximum resolution and cannot be upscaled further.";
        } else {
            savepopuptitle.textContent = "Upscale Failed";
            savepopuptext.textContent =
                "There was an issue while upscaling the image. Please try again.";
        }

        // Hide popup after 3 seconds
        setTimeout(() => {
            if (savepopup) savepopup.style.display = "none";
        }, 3000);
    }
}
function base64ToFile(base64, filename = "image.jpeg") {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

// Boost Button event
document.querySelector(".boost-img-btn").addEventListener("click", (e) => {

    // ✅ Continue normal flow
    const userId = window.shopifyCustomerId || "guest";
    const sessionId = getLocalStorage1Day("sessionId") || "none";

    const mainImgWrap = document.querySelector(".main-img-wrap");
    if (!mainImgWrap) {
        console.error("No .main-img-wrap found.");
        return;
    }

    const dpidata = appState.dpi || 0;
    const printHeightdata = appState.printimghight || 0;
    const printWidthdata = appState.printimgwidth || 0;

    const dataMainImg = mainImgWrap.getAttribute("data-main-img");
    if (!dataMainImg) {
        console.error("No data-main-img found.");
        return;
    }

    if (dataMainImg.startsWith("http")) {
        upscaleAndFixDPI({
            customerId: userId,
            sessionId: sessionId,
            dpi: dpidata,
            printWidth: printWidthdata,
            printHeight: printHeightdata,
            imageUrl: dataMainImg
        });
    }
    else if (dataMainImg.startsWith("data:image")) {
        const file = base64ToFile(dataMainImg, "uploaded.jpeg");
        upscaleAndFixDPI({
            customerId: userId,
            sessionId: sessionId,
            dpi: dpidata,
            printWidth: printWidthdata,
            printHeight: printHeightdata,
            file: file
        });
    }
    else {
        console.error("Invalid data-main-img format.");
    }
});


function getCroppedCanvas() {
    let innerPadding;

    const frnheight = appState.orgHeight;
    const frmwidth = appState.orgWidth;
    let size = `${frmwidth}x${frnheight}`;

    if (size === "864x864") {
        innerPadding = 144 / 2.16;
    } else if (size === "1056x1056") {
        innerPadding = 144 / 2.64;
    } else if (size === "1056x1248") {
        innerPadding = 144 / 3.12;
    } else if (size === "1056x1440") {
        innerPadding = 144 / 3.68;
    } else if (size === "1152x1440") {
        innerPadding = 144 / 3.60;
    } else if (size === "1248x1248") {
        innerPadding = 144 / 3.12;
    } else if (size === "1248x2208") {
        innerPadding = 144 / 9.77;
    } else if (size === "1344x1632") {
        innerPadding = 144 / 4.08;
    } else if (size === "1440x1440") {
        innerPadding = 144 / 3.60;
    } else if (size === "1440x1824") {
        innerPadding = 144 / 4.59;
    } else if (size === "1440x2016") {
        innerPadding = 144 / 5.04;
    } else if (size === "1440x2592") {
        innerPadding = 144 / 6.48;
    } else if (size === "1440x3744") {
        innerPadding = 144 / 9.36;
    } else if (size === "1632x1632") {
        innerPadding = 144 / 4.08;
    } else if (size === "1824x1824") {
        innerPadding = 144 / 4.56;
    } else if (size === "1824x2208") {
        innerPadding = 144 / 5.52;
    } else if (size === "1824x2592") {
        innerPadding = 144 / 6.41;
    } else if (size === "1824x3360") {
        innerPadding = 144 / 8.40;
    } else if (size === "1824x4696") {
        innerPadding = 144 / 11.84;
    } else if (size === "2016x2016") {
        innerPadding = 144 / 5.04;
    } else if (size === "2016x2592") {
        innerPadding = 144 / 6.48;
    } else if (size === "2016x2784") {
        innerPadding = 144 / 6.96;
    } else if (size === "2208x2208") {
        innerPadding = 144 / 5.52;
    } else if (size === "2208x2592") {
        innerPadding = 144 / 6.48;
    } else if (size === "2208x2976") {
        innerPadding = 144 / 7.50;
    } else if (size === "2208x3168") {
        innerPadding = 144 / 7.92;
    } else if (size === "2208x4128") {
        innerPadding = 144 / 10.32;
    } else if (size === "2208x6048") {
        innerPadding = 144 / 15.12;
    } else if (size === "2592x2592") {
        innerPadding = 144 / 6.48;
    } else if (size === "2592x3072") {
        innerPadding = 144 / 7.62;
    } else if (size === "2592x3360") {
        innerPadding = 144 / 8.40;
    } else if (size === "2592x3744") {
        innerPadding = 144 / 9.36;
    } else if (size === "2592x4896") {
        innerPadding = 144 / 12.24;
    } else if (size === "2784x2784") {
        innerPadding = 144 / 6.96;
    } else if (size === "2784x4128") {
        innerPadding = 144 / 10.32;
    } else if (size === "2976x2976") {
        innerPadding = 144 / 7.44;
    } else if (size === "2976x4128") {
        innerPadding = 144 / 10.32;
    } else if (size === "3168x3168") {
        innerPadding = 144 / 7.92;
    } else if (size === "3168x4128") {
        innerPadding = 144 / 10.32;
    } else if (size === "3168x6048") {
        innerPadding = 144 / 15.12;
    } else if (size === "3360x3360") {
        innerPadding = 144 / 8.40;
    } else if (size === "3360x4896") {
        innerPadding = 144 / 12.24;
    } else if (size === "3744x3744") {
        innerPadding = 144 / 9.36;
    } else if (size === "3840x3840") {
        innerPadding = 144 / 9.60;
    } else if (size === "4128x5568") {
        innerPadding = 144 / 13.92;
    } else if (size === "4128x6048") {
        innerPadding = 144 / 15.12;
    } else {
        innerPadding = null;
    }

    const sw = canvas.width - innerPadding * 2;
    const sh = canvas.height - innerPadding * 2;

    mockupState.croppedWidth = sw;
    mockupState.croppedHeight = sh;

    const cropped = document.createElement("canvas");
    cropped.width = sw;
    cropped.height = sh;
    const ctx = cropped.getContext("2d");

    ctx.drawImage(
        canvas.lowerCanvasEl,
        innerPadding, innerPadding, sw, sh,
        0, 0, sw, sh
    );

    return cropped;
}

// Function to insert cropped image into mockups
function insertIntoMockups() {
    const croppedCanvas = getCroppedCanvas();
    const mockupCanvases = document.querySelectorAll(".mockup-canvas");

    mockupCanvases.forEach((mockupCanvas, index) => {
        const ctx = mockupCanvas.getContext("2d");
        ctx.clearRect(0, 0, mockupCanvas.width, mockupCanvas.height);

        const { x, y, w, h } = mockupPlacements[index];

        ctx.drawImage(
            croppedCanvas,
            mockupCanvas.width * x,
            mockupCanvas.height * y,
            mockupCanvas.width * w,
            mockupCanvas.height * h
        );
    });
}

document.getElementById("insertBtn")?.addEventListener("click", insertIntoMockups);

document.addEventListener("DOMContentLoaded", () => {
    const currentUrl = window.location.pathname;
    const links = document.querySelectorAll(".pdp-tab-wrap .pill");

    links.forEach(link => {
        if (link.getAttribute("href") === currentUrl) {
            link.classList.add("active");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const highlightedOptions = [];

    const relatedOptionsMap = {
        '9″×12″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
        '12″×16″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
        '18″×24″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
        '24″×32″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
        '30″×40″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
        '8″×12″': ["26″×40″"], '12″×18″': ["26″×40″"], '16″×24″': ["26″×40″"],
        '20″×30″': ["26″×40″"], '24″×36″': ["26″×40″"], '32″×48″': ["26″×40″"],
        '40″×60″': ["26″×40″"], '8″×10″': ["11″×14″", "20″×24″"],
        '16″×20″': ["11″×14″", "20″×24″"],
        '24″×30″': ["11″×14″", "20″×24″"],
    };

    function highlightMatchingOption() {
        const hiddenimg = document.getElementById("frame-img-position");
        const orientationRadio = document.querySelector('input[name="orientation"]:checked');
        const orientation = orientationRadio ? orientationRadio.value : "portrait";


        // ⛔ STOP if orientation is NOT portrait
        if (orientation !== "portrait") {
            console.log("Orientation is landscape → skipping highlight logic");
            return true;  // stop interval
        }

        const imgRatioEl = document.getElementById("img-ratio");
        if (!imgRatioEl) {
            return;
        }

        const ratioValue = imgRatioEl.textContent.trim() || imgRatioEl.value?.trim();
        if (!ratioValue) {
            return false;
        }

        const options = document.querySelectorAll("#frameSizeOptions label.frame-size-btn input");
        let matchFound = false;

        options.forEach((input, index) => {
            const lRatio = input.getAttribute("data-l-ratio");
            const pRatio = input.getAttribute("data-p-ratio");
            const label = input.closest("label.frame-size-btn").querySelector("span");

            if (ratioValue === lRatio || ratioValue === pRatio) {
                label.style.border = "1px solid green";

                matchFound = true;

                if (!highlightedOptions.includes(input.value)) {
                    highlightedOptions.push(input.value);
                }
            } else {
                label.style.border = "1px solid #333";
            }
        });

        if (matchFound) {
            highlightedOptions.forEach((val) => {
                if (relatedOptionsMap[val]) {
                    relatedOptionsMap[val].forEach((relatedVal) => {
                        highlightRelatedOption(relatedVal);
                    });
                }
            });
        }

        return true;
    }

    function highlightRelatedOption(targetValue) {
        const options = document.querySelectorAll("#frameSizeOptions label.frame-size-btn input ");
        let found = false;

        options.forEach((input) => {
            const normalizedInput = input.value.replace(/[“”"]/g, '"').replace(/[×x]/g, "x");
            const normalizedTarget = targetValue.replace(/[“”"]/g, '"').replace(/[×x]/g, "x");
            if (normalizedInput === normalizedTarget) {
                const label = input.closest("label.frame-size-btn").querySelector("span");
                label.style.border = "1px solid orange";

                found = true;

                if (!highlightedOptions.includes(input.value)) {
                    highlightedOptions.push(input.value);
                }
            }
        });
    }

    const ratioCheckInterval = setInterval(() => {
        const done = highlightMatchingOption();
        if (done) {
            clearInterval(ratioCheckInterval);
        }
    }, 300);
});

const canvasnew = document.getElementById('canvasnew');
const fileInput1 = document.getElementById('upload-image');
const ctx = canvasnew.getContext('2d');
const expandBtn = document.getElementById('expandBtn');

let img = new Image();
img.crossOrigin = "anonymous";

// 🧮 Calculate expanded size
function calculateExpandedSize({
    imageWidthPx,
    imageHeightPx,
    imageWidthInch,
    imageHeightInch,
    canvasWidthInch,
    canvasHeightInch
}) {
    const extraWidthInch = canvasWidthInch - imageWidthInch;
    const extraHeightInch = canvasHeightInch - imageHeightInch;

    const extraWidthPx = (extraWidthInch * imageWidthPx) / imageWidthInch;
    const extraHeightPx = (extraHeightInch * imageHeightPx) / imageHeightInch;

    const finalWidthPx = imageWidthPx + extraWidthPx;
    const finalHeightPx = imageHeightPx + extraHeightPx;

    return { extraWidthPx, extraHeightPx, finalWidthPx, finalHeightPx };
}

expandBtn.addEventListener('click', async () => {
    if (!appState.uploadedImage) {
        alert("Please upload an image first!");
        return;
    }

    let file = fileInput1.files[0];
    if (!file) {
        alert("Please upload an image first!");
        return;
    }

    if (posterPdpIsHeicFile(file)) {
        try {
            file = await posterPdpConvertHeicToJpeg(file);
            if (!file) return;
        } catch (err) {
            console.error("HEIC expansion conversion failed:", err);
            return;
        }
    }

    const imgWidthPx = appState.uploadedImage.width;
    const imgHeightPx = appState.uploadedImage.height;
    const imgWidthIn = appState.printimgwidth;
    const imgHeightIn = appState.printimghight;
    const canvasWidthIn = appState.extendwidth;
    const canvasHeightIn = appState.extendheight;

    // ✅ Get user and session IDs
    const userId = window.shopifyCustomerId || "guest";
    const sessionId = getLocalStorage1Day("sessionId") || "none";

    const size = calculateExpandedSize({
        imageWidthPx: imgWidthPx,
        imageHeightPx: imgHeightPx,
        imageWidthInch: imgWidthIn,
        imageHeightInch: imgHeightIn,
        canvasWidthInch: canvasWidthIn,
        canvasHeightInch: canvasHeightIn
    });

    console.log("📏 Calculated Sizes:", size);

    const reader = new FileReader();
    reader.onload = e => {
        img.src = e.target.result;
        img.onload = async () => await processImage(size);
    };
    reader.readAsDataURL(file);

    // 🧩 Process & Upload
    async function processImage(size) {
        const { finalWidthPx, finalHeightPx } = size;

        // Draw expanded image
        canvasnew.width = finalWidthPx;
        canvasnew.height = finalHeightPx;

        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, canvasnew.width, canvasnew.height);

        const x = (canvasnew.width - imgWidthPx) / 2;
        const y = (canvasnew.height - imgHeightPx) / 2;

        ctx.drawImage(img, x, y, imgWidthPx, imgHeightPx);

        // Convert to Blob
        const blob = await new Promise(resolve => canvasnew.toBlob(resolve, 'image/jpeg'));
        const file = new File([blob], "expanded-image.jpeg", { type: "image/jpeg" });

        // 🔹 Prepare FormData
        const formData = new FormData();
        formData.append("customerId", userId);
        formData.append("sessionId", sessionId);
        formData.append("file", file);

        try {
            console.log("⬆️ Uploading image to API...");
            const response = await fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
                method: "POST",
                headers: {
                    "x-api-key": window.Prompt2Prints.apiKey
                },
                body: formData
            });

            if (!response.ok) throw new Error(`Upload failed (${response.status})`);
            const result = await response.json();

            const imageUpscale = document.querySelector('input[name="properties[_pdp-allow-upscale]"]');
            const imageUpscaletag = document.querySelector('input[name="properties[_pdp-img-tag]"]');

            if (!imageUpscale || !imageUpscaletag) {
                console.warn("Upscale inputs not found");
                return;
            }

            const flag = (result.flag || "").toLowerCase();

            if (flag === "standard") {
                imageUpscale.value = "true";
                imageUpscaletag.value = "Standard";
            }
            else if (flag === "professional") {
                imageUpscale.value = "false";
                imageUpscaletag.value = "Professional";
            }
            else {
                imageUpscale.value = "";
                imageUpscaletag.value = "";
            }

            // Optional: also update attribute for Shopify forms
            imageUpscale.setAttribute("value", imageUpscale.value);
            imageUpscaletag.setAttribute("value", imageUpscaletag.value);

            const base64 = canvasnew.toDataURL('image/jpeg');
            const link = document.createElement('a');
            link.download = 'expanded-image.jpeg';
            link.href = base64;
            link.click();

        } catch (err) {
            console.error("❌ Upload error:", err);
            alert("Upload failed. Please try again.");
        }
    }
});

// CORRECTED BLACK EDGE CANVAS CODE
const canvasnewblack = document.getElementById('canvasblackedge');
const ctx1 = canvasnewblack.getContext('2d');

let img1 = new Image();
img1.crossOrigin = "anonymous";

// Corrected file input event listener
uploadInput.addEventListener("change", (e) => {
    (async () => {
        let file = e.target.files[0];
        if (!file) return;

        if (posterPdpIsHeicFile(file)) {
            try {
                file = await posterPdpConvertHeicToJpeg(file);
                if (!file) return;
            } catch (err) {
                console.error("HEIC black-edge conversion failed:", err);
                return;
            }
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            img1.src = event.target.result;
            img1.onload = () => {
                // Store the image for later use
                appState.uploadedImageForBlackEdge = img1;
                console.log("Image loaded for black edge:", img1.width, img1.height);
            };
        };
        reader.readAsDataURL(file);
    })();
});

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".pdp-option-main-wrap");

    items.forEach(item => {
        const header = item.querySelector(".pdp-option-title-wrap.is-layout");
        const content = item.querySelector(".orientation-options");
        const arrow = item.querySelector(".pdp-option-arrow");

        if (!header || !content) return;

        content.style.display = "none";

        // Default open
        if (item.classList.contains("default-open")) {
            item.classList.add("active");
            header.setAttribute("aria-expanded", "true");
            content.style.display = "grid";
            if (arrow) arrow.style.transform = "rotate(180deg)";
        }

        header.addEventListener("click", () => {
            const expanded = header.getAttribute("aria-expanded") === "true";

            item.classList.toggle("active");
            header.setAttribute("aria-expanded", !expanded);

            if (expanded) {
                content.style.display = "none";
                if (arrow) arrow.style.transform = "rotate(0deg)";
            } else {
                content.style.display = "grid";
                if (arrow) arrow.style.transform = "rotate(180deg)";
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".frame-sizes");

    items.forEach(item => {
        const header = item.querySelector(".pdp-option-title-wrap.is-size");
        const content = item.querySelector(".frame-size-options");
        const arrow = item.querySelector(".pdp-option-arrow");

        if (!header || !content) return;

        content.style.display = "none";

        // Default open
        if (item.classList.contains("default-open")) {
            item.classList.add("active");
            header.setAttribute("aria-expanded", "true");
            content.style.display = "flex";
            if (arrow) arrow.style.transform = "rotate(180deg)";
        }

        header.addEventListener("click", () => {
            const expanded = header.getAttribute("aria-expanded") === "true";

            item.classList.toggle("active");
            header.setAttribute("aria-expanded", !expanded);

            if (expanded) {
                content.style.display = "none";
                if (arrow) arrow.style.transform = "rotate(0deg)";
            } else {
                content.style.display = "flex";
                if (arrow) arrow.style.transform = "rotate(180deg)";
            }
        });
    });
});

// Helper functions that were missing
function getLocalStorage1Day(key) {
    try {
        const item = localStorage.getItem(key);
        if (!item) return null;

        // Check if the item is already a JSON string with expiry
        if (item.startsWith('{') && item.includes('"expiry"')) {
            const { value, expiry } = JSON.parse(item);

            // Check if the item has expired
            if (Date.now() > expiry) {
                localStorage.removeItem(key);
                return null;
            }

            return value;
        } else {
            // It's a regular string, return as-is
            return item;
        }
    } catch (error) {
        console.error('Error reading from localStorage:', error);
        // Return the raw item if parsing fails
        return item;
    }
}

function setLocalStorage1Day(key, value) {
    try {
        // Set expiry to 1 day from now
        const expiry = Date.now() + (24 * 60 * 60 * 1000);
        const item = JSON.stringify({ value, expiry });
        localStorage.setItem(key, item);
    } catch (error) {
        console.error('Error writing to localStorage:', error);
    }
}

// Initialize any missing appState properties
if (!appState.uploadedImageForBlackEdge) {
    appState.uploadedImageForBlackEdge = null;
}

document.getElementById("fit-front-image").addEventListener("click", () => {
    appState.selectedEdgeType = "FitToPlaceholder";
    fitImageToFrame(false);
    updatePositionInfo();
});
document.getElementById("fill-front-image").addEventListener("click", () => {
    appState.selectedEdgeType = "FillToPlaceholder";
    fitImageToFrame(true);
    updatePositionInfo();
});

document.getElementById("center-image").addEventListener("click", () => {
    appState.selectedEdgeType = "CenterImage";
    centerImage();
    const wasCapped = enforceMinimumDpi(MIN_PRINT_DPI);
    if (wasCapped) {
        showZoomLimitMessage();
    } else {
        syncZoomSlider();
        updateZoomControlsState();
    }
});

window.getLocalStorage1Day = getLocalStorage1Day;
window.setLocalStorage1Day = setLocalStorage1Day;
window.appState = appState;

// Additional function to reset zoom when needed
function resetZoom() {
    if (!appState.uploadedImage) return;
    updateZoom(1.0);
}

// Add event listener for "Fit to Frame" button if it exists
document.querySelectorAll(".fit-to-frame-btn").forEach(btn => {
    btn.addEventListener("click", () => {
        fitImageToFrame(false);
        resetZoom();
    });
});

// Function to handle canvas resize and update zoom limits
function handleCanvasResize() {
    if (appState.uploadedImage) {
        syncZoomSlider();
        updateZoom(appState.zoom);
    }
}

// Add canvas resize observer if needed
const resizeObserver = new ResizeObserver(() => {
    handleCanvasResize();
});

// Start observing the canvas container
const canvasContainer = document.getElementById("image-canvas").parentElement;
if (canvasContainer) {
    resizeObserver.observe(canvasContainer);
}

// Cleanup function
window.addEventListener("beforeunload", () => {
    if (resizeObserver) {
        resizeObserver.disconnect();
    }
});

document.querySelector('.frm-note-close').addEventListener('click', () => {
    document.querySelector('.frm-image-note').style.display = 'none';
});

document.addEventListener('DOMContentLoaded', function () {
    // Ensure canvas is touch-friendly
    if (canvas.wrapperEl) {
        canvas.wrapperEl.style.touchAction = 'none';
        canvas.wrapperEl.style.webkitTapHighlightColor = 'transparent';
    }
});


